import React, { useState, useRef, useEffect } from 'react';
import './Home.css';
import './Home.manual.css';

function Home() {
  const [howItWorksIndex, setHowItWorksIndex] = useState(0);

  // Mobile Safari/Chrome only honor autoplay when the video's `muted`
  // DOM *property* is set before playback starts — React only sets the
  // `muted` attribute via JSX, which some mobile browsers ignore for the
  // autoplay-permission check, so the "Glob" video silently never starts
  // on phones even though it plays fine on desktop. Setting it
  // imperatively and re-triggering play() on mount fixes it everywhere.
  const globeVideoRef = useRef(null);
  useEffect(() => {
    const video = globeVideoRef.current;
    if (!video) return;
    video.muted = true;
    video.play().catch(() => {});
  }, []);

  // Framer's marquee scrolled infinitely via a JS rAF loop that duplicated
  // this list at runtime for a seamless loop — stripped along with all
  // other scripts. Defining the logo list once and rendering it twice lets
  // a plain CSS keyframe animation (see .marquee-track in Home.css) scroll
  // a track that's exactly double the visible width by exactly 50%,
  // looping seamlessly without needing to duplicate this JSX by hand.
  const partnerLogoItems = (
    <>
      <li>
        <div className="framer-1qq14x2 home-s138" data-framer-name="image 270">
          <div data-framer-background-image-wrapper="true" className="home-s31">
            <img
              decoding="async"
              width="492"
              height="160"
              src="/framerusercontent.com/images/ivSPK23J9RR1a4Hco5h0JeDko.png"
              alt=""
              className="home-s44"
            />
          </div>
        </div>
      </li>
      <li>
        <div className="framer-1r6uxem home-s138" data-framer-name="image 273">
          <div data-framer-background-image-wrapper="true" className="home-s31">
            <img
              decoding="async"
              width="480"
              height="160"
              src="/framerusercontent.com/images/moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
              alt=""
              className="home-s44"
            />
          </div>
          <div
            className="framer-773w4g"
            data-framer-name="Item → image 273 → moiOlfaGZqQcDQ2Z13c1uKUzPI.png"
          >
            <div
              data-framer-background-image-wrapper="true"
              className="home-s31"
            >
              <img
                decoding="async"
                width="480"
                height="160"
                src="/framerusercontent.com/images/VsSBYBESvevipPgqh18FJ54Fezw.png"
                alt=""
                className="home-s44"
              />
            </div>
          </div>
        </div>
      </li>
      <li>
        <div className="framer-rxtob9 home-s138" data-framer-name="image 293">
          <div data-framer-background-image-wrapper="true" className="home-s31">
            <img
              decoding="async"
              width="548"
              height="168"
              sizes="(min-width: 1440px) 137px, (min-width: 810px) and (max-width: 1439.98px) 137px, (max-width: 809.98px) 137px"
              srcSet="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 512w,/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png 548w"
              src="/framerusercontent.com/images/iIEMSIRUdZmveweRPf1nbqui87Y.png"
              alt=""
              className="home-s44"
            />
          </div>
        </div>
      </li>
      <li>
        <div
          className="framer-1vb4gv0 home-s138"
          data-framer-name="SWIFT logo.svg"
        >
          <div data-framer-background-image-wrapper="true" className="home-s31">
            <img
              decoding="async"
              width="1280"
              height="1280"
              sizes="(min-width: 1440px) 139px, (min-width: 810px) and (max-width: 1439.98px) 139px, (max-width: 809.98px) 139px"
              srcSet="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 512w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1024w,/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png 1280w"
              src="/framerusercontent.com/images/km6jv13htIgnkxe33gYYSANahWY.png"
              alt=""
              className="home-s32"
            />
          </div>
        </div>
      </li>
    </>
  );

  return (
    <div className="page-home">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg-726352421_1977"
          >
            <rect width="40" height="40" rx="20" fill="#E8E8E8" />
            <path
              d="M29.1681 28.6838C19.0481 33.5 12.7675 29.4704 8.74716 27.0229C8.49838 26.8686 8.07555 27.0589 8.44242 27.4803C9.78181 29.1044 14.1713 33.0188 19.9008 33.0188C25.6343 33.0188 29.0452 29.8903 29.4718 29.3446C29.8956 28.8035 29.5963 28.505 29.168 28.6838H29.1681ZM32.0102 27.1141C31.7385 26.7603 30.3577 26.6943 29.4888 26.801C28.6185 26.9047 27.3122 27.4366 27.4257 27.756C27.484 27.8756 27.603 27.8219 28.2008 27.7682C28.8003 27.7084 30.4798 27.4964 30.8297 27.9539C31.1813 28.4145 30.2941 30.6088 30.132 30.9627C29.9755 31.3166 30.1918 31.4078 30.4859 31.1721C30.7759 30.9365 31.301 30.3264 31.6534 29.4629C32.0033 28.5947 32.2168 27.3836 32.0102 27.1141Z"
              fill="#FF9900"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.3635 18.8562C22.3635 20.1199 22.3955 21.1738 21.7567 22.2961C21.2412 23.2086 20.4246 23.7697 19.5121 23.7697C18.2666 23.7697 17.5412 22.8207 17.5412 21.4202C17.5412 18.6554 20.0184 18.1537 22.3635 18.1537V18.8562ZM25.6346 26.7626C25.4201 26.9541 25.1099 26.9679 24.8682 26.8401C23.7915 25.9459 23.5998 25.5308 23.0068 24.6776C21.2275 26.4934 19.9683 27.0362 17.6599 27.0362C14.9317 27.0362 12.8057 25.3528 12.8057 21.9813C12.8057 19.349 14.2337 17.556 16.2638 16.6801C18.0248 15.9044 20.4839 15.7676 22.3635 15.5532V15.1335C22.3635 14.3624 22.4228 13.45 21.9712 12.784C21.5742 12.1863 20.8169 11.9399 20.1508 11.9399C18.9145 11.9399 17.8104 12.574 17.5412 13.888C17.4864 14.18 17.2721 14.4674 16.9801 14.4811L13.8321 14.1436C13.5676 14.0841 13.2756 13.8698 13.3486 13.4637C14.074 9.64975 17.5183 8.5 20.6024 8.5C22.1809 8.5 24.243 8.91976 25.4885 10.1151C27.0671 11.5886 26.9165 13.5549 26.9165 15.6946V20.7495C26.9165 22.2688 27.5461 22.9348 28.1391 23.7561C28.349 24.048 28.3946 24.3994 28.13 24.6183C27.4685 25.1703 26.2914 26.1968 25.6436 26.7717L25.6346 26.7626Z"
              fill="black"
            />
          </svg>
          <svg
            width="52"
            height="56"
            viewBox="0 0 52 56"
            fill="none"
            id="svg764373717_1237"
          >
            <path
              d="M4.1178 43.9966C6.70645 44.1861 9.19117 44.3576 11.6734 44.5383C12.1685 44.5721 12.5179 44.5965 13.1315 44.7412C13.5884 44.8438 14.5526 45.0824 14.3386 45.549C14.1216 45.9159 13.9208 46.1488 13.0542 46.1736C10.8158 46.2263 8.58772 45.9456 6.37559 45.6791C4.42238 45.4424 2.9366 45.2321 1.2209 44.9207C0.419624 44.7752 0.20983 44.3038 0.494828 43.6091C0.750833 42.9857 1.00256 42.3414 1.37105 41.7778C2.68853 39.7385 4.05394 37.7418 5.40585 35.7216C5.57222 35.4696 5.68687 35.2631 5.9277 34.9915C6.22271 34.6653 6.41922 34.4115 6.78617 34.6284C7.13714 34.8312 6.97041 35.3797 6.83171 35.6391C5.72009 37.8323 3.35158 42.3184 3.27991 42.5858C4.69575 42.1348 6.01556 41.7471 7.31578 41.2848C16.3552 38.0228 25.0854 34.1441 32.7865 28.24C38.8826 23.5665 44.3202 18.2519 48.9332 12.1036C49.208 11.7422 49.5172 11.4 49.8214 11.0762C50.2273 10.6314 50.5172 10.4718 50.7617 10.6659C51.1715 11.092 50.973 11.4639 50.8404 11.7743C50.5844 12.3977 50.1925 12.9748 49.8148 13.5359C44.6841 20.9889 38.103 26.9559 30.7091 32.0823C23.1207 37.3445 14.6704 40.6952 5.9054 43.3388C5.43779 43.4606 4.30986 43.8701 4.1178 43.9966Z"
              fill="black"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-738554790_445"
          >
            <path
              d="M0.461426 11.5386H11.5383M1.07681 4.76936V11.5386M10.923 4.76936V11.5386M3.53835 7.2309V9.07705M5.99989 7.2309V9.07705M8.46143 7.2309V9.07705M5.99989 2.92321H6.00604M0.461426 4.76936H11.5383V2.92321L5.99989 0.46167L0.461426 2.92321V4.76936Z"
              stroke="#2563EB"
              strokeWidth={1.22948}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="14"
            height="7"
            viewBox="-1 -1 14 7"
            fill="none"
            id="svg95803052_220"
          >
            <path
              opacity="0.12"
              d="M11.5383 2.92321L5.99989 0.46167L0.461426 2.92321V4.76936H11.5383V2.92321Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="59"
            height="61"
            viewBox="0 0 59 61"
            fill="none"
            id="svg147118731_1233"
          >
            <path
              d="M33.2756 3.78131C31.3111 5.47779 29.4329 7.11348 27.5499 8.74089C27.1759 9.06708 26.9116 9.29684 26.3754 9.62848C25.9797 9.87896 25.1293 10.392 24.9507 9.91078C24.8446 9.49791 24.8219 9.19126 25.4172 8.56089C26.9627 6.9409 28.7367 5.56386 30.4894 4.18811C32.0379 2.97434 33.2372 2.07243 34.6706 1.07947C35.34 0.615768 35.8217 0.800754 36.1114 1.49351C36.3712 2.11533 36.6488 2.74891 36.7867 3.408C37.2971 5.78157 37.7436 8.15898 38.2161 10.5434C38.2766 10.8392 38.3416 11.0663 38.3633 11.4286C38.3854 11.8679 38.4259 12.1864 38.013 12.2924C37.6215 12.3972 37.3516 11.8915 37.2662 11.61C36.5014 9.27309 35.0041 4.4262 34.8656 4.18639C34.1834 5.50645 33.5243 6.71389 32.9318 7.96012C28.8465 16.6586 25.416 25.5744 24.1454 35.1948C23.1394 42.81 23.0524 50.4129 24.138 58.0224C24.1993 58.4722 24.2226 58.9328 24.2365 59.3769C24.264 59.9784 24.1719 60.2962 23.8617 60.3319C23.2707 60.3204 23.1481 59.917 23.0223 59.6037C22.7625 58.9819 22.6316 58.2968 22.5019 57.6329C20.8598 48.7349 21.294 39.862 22.8973 31.0088C24.5423 21.9221 28.1482 13.5776 32.4767 5.5105C32.7212 5.09369 33.2292 4.00655 33.2756 3.78131Z"
              fill="black"
            />
          </svg>
          <svg
            width="14"
            height="11"
            viewBox="-1 -1 14 11"
            fill="none"
            id="svg-212988539_408"
          >
            <path
              opacity="0.12"
              d="M1.69171 8.53839H10.3071C10.9868 8.53839 11.5379 7.99421 11.5379 7.32293V1.24561C11.5379 0.574333 10.9868 0.0301514 10.3071 0.0301514H1.69171C1.01197 0.0301514 0.460938 0.574333 0.460938 1.24561V3.06881V7.32293C0.460938 7.99421 1.01197 8.53839 1.69171 8.53839Z"
              fill="#2563EB"
            />
          </svg>
          <svg
            width="14"
            height="14"
            viewBox="-1 -1 14 14"
            fill="none"
            id="svg-1448888000_2617"
          >
            <path
              d="M1.3025 2.75332L1.11028 2.16941H1.11028L1.3025 2.75332ZM8.07174 0.524975L8.26395 1.10889L8.07174 0.524975ZM8.76863 6.66973C8.42912 6.66973 8.15389 6.94496 8.15389 7.28448C8.15389 7.62399 8.42912 7.89922 8.76863 7.89922V6.66973ZM8.77478 7.89922C9.1143 7.89922 9.38953 7.62399 9.38953 7.28448C9.38953 6.94496 9.1143 6.66973 8.77478 6.66973V7.89922ZM10.3071 11.5386V10.9239H1.69171V11.5386V12.1533H10.3071V11.5386ZM0.460938 10.3231H1.07568V6.06901H0.460938H-0.153804V10.3231H0.460938ZM0.460938 6.06901H1.07568V4.24582H0.460938H-0.153804V6.06901H0.460938ZM1.69171 11.5386V10.9239C1.34421 10.9239 1.07568 10.6477 1.07568 10.3231H0.460938H-0.153804C-0.153804 11.3412 0.679735 12.1533 1.69171 12.1533V11.5386ZM1.69171 3.03036V2.41561C0.679735 2.41561 -0.153804 3.22779 -0.153804 4.24582H0.460938H1.07568C1.07568 3.92128 1.34421 3.6451 1.69171 3.6451V3.03036ZM10.3071 11.5386V12.1533C11.3191 12.1533 12.1526 11.3412 12.1526 10.3231H11.5379H10.9231C10.9231 10.6477 10.6546 10.9239 10.3071 10.9239V11.5386ZM11.5379 4.24582H12.1526C12.1526 3.2278 11.3191 2.41561 10.3071 2.41561V3.03036V3.6451C10.6546 3.6451 10.9231 3.92128 10.9231 4.24582H11.5379ZM9.69171 1.67806H9.07697V2.78204H9.69171H10.3064V1.67806H9.69171ZM0.460938 6.06901H1.07568V3.90641H0.460938H-0.153804V6.06901H0.460938ZM1.3025 2.75332L1.49472 3.33724L8.26395 1.10889L8.07174 0.524975L7.87952 -0.058942L1.11028 2.16941L1.3025 2.75332ZM0.460938 3.90641H1.07568C1.07568 3.65281 1.24035 3.42098 1.49472 3.33724L1.3025 2.75332L1.11028 2.16941C0.359503 2.41655 -0.153804 3.11367 -0.153804 3.90641H0.460938ZM9.69171 1.67806H10.3064C10.3064 0.418947 9.06374 -0.448774 7.87952 -0.058942L8.07174 0.524975L8.26395 1.10889C8.67365 0.974025 9.07697 1.27794 9.07697 1.67806H9.69171ZM8.76863 7.28448V7.89922H8.77478V7.28448V6.66973H8.76863V7.28448ZM9.07632 7.28448H8.46158C8.46158 7.10555 8.60633 6.9736 8.76863 6.9736V7.58834V8.20308C9.2708 8.20308 9.69106 7.79904 9.69106 7.28448H9.07632ZM8.76863 7.58834V6.9736C8.93093 6.9736 9.07568 7.10555 9.07568 7.28448H8.46094H7.8462C7.8462 7.79904 8.26646 8.20308 8.76863 8.20308V7.58834ZM8.46094 7.28448H9.07568C9.07568 7.4634 8.93093 7.59535 8.76863 7.59535V6.98061V6.36587C8.26646 6.36587 7.8462 6.76991 7.8462 7.28448H8.46094ZM8.76863 6.98061V7.59535C8.60633 7.59535 8.46158 7.4634 8.46158 7.28448H9.07632H9.69106C9.69106 6.76991 9.2708 6.36587 8.76863 6.36587V6.98061ZM11.5379 10.3231H12.1526V4.24582H11.5379H10.9231V10.3231H11.5379ZM10.3071 3.03036V2.41561H1.69171V3.03036V3.6451H10.3071V3.03036Z"
              fill="#2563EB"
            />
          </svg>
          <svg viewBox="0 0 180 60" overflow="visible" id="svg1322499166_10645">
            <g>
              <path d="M 0 60 L 0 0 L 180 0 L 180 60 Z" fill="transparent" />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 122.291 28.802 L 122.291 32.239 L 120.137 32.239 L 120.137 34.492 L 122.291 34.492 L 122.291 42.15 C 122.291 44.764 123.474 45.81 126.449 45.81 C 126.972 45.81 127.471 45.748 127.906 45.673 L 127.906 43.445 C 127.533 43.482 127.296 43.507 126.885 43.507 C 125.553 43.507 124.968 42.884 124.968 41.465 L 124.968 34.492 L 127.906 34.492 L 127.906 32.239 L 124.968 32.239 L 124.968 28.802 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 135.486 45.997 C 139.445 45.997 141.873 43.345 141.873 38.95 C 141.873 34.579 139.433 31.915 135.486 31.915 C 131.526 31.915 129.086 34.579 129.086 38.95 C 129.086 43.345 131.514 45.997 135.486 45.997 Z M 135.486 43.619 C 133.158 43.619 131.85 41.913 131.85 38.95 C 131.85 36.011 133.158 34.293 135.486 34.293 C 137.802 34.293 139.122 36.011 139.122 38.95 C 139.122 41.901 137.802 43.619 135.486 43.619 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.949 45.736 L 146.626 45.736 L 146.626 37.73 C 146.626 35.825 148.058 34.542 150.088 34.542 C 150.56 34.542 151.358 34.629 151.582 34.704 L 151.582 32.064 C 151.295 31.989 150.785 31.952 150.386 31.952 C 148.618 31.952 147.112 32.923 146.726 34.256 L 146.527 34.256 L 146.527 32.176 L 143.949 32.176 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 158.229 34.193 C 160.209 34.193 161.504 35.575 161.567 37.705 L 154.718 37.705 C 154.868 35.588 156.249 34.193 158.229 34.193 Z M 161.555 42.075 C 161.057 43.133 159.948 43.719 158.33 43.719 C 156.188 43.719 154.806 42.212 154.718 39.834 L 154.718 39.684 L 164.294 39.684 L 164.294 38.751 C 164.294 34.492 162.015 31.915 158.243 31.915 C 154.419 31.915 151.992 34.666 151.992 39 C 151.992 43.333 154.37 45.997 158.255 45.997 C 161.355 45.997 163.521 44.503 164.132 42.075 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 104.734 40.728 C 104.941 44.058 107.716 46.187 111.845 46.187 C 116.259 46.187 119.021 43.955 119.021 40.393 C 119.021 37.592 117.446 36.044 113.626 35.153 L 111.574 34.65 C 109.148 34.082 108.167 33.321 108.167 31.992 C 108.167 30.314 109.69 29.217 111.974 29.217 C 114.142 29.217 115.639 30.288 115.91 32.005 L 118.724 32.005 C 118.556 28.868 115.794 26.662 112.013 26.662 C 107.948 26.662 105.238 28.868 105.238 32.185 C 105.238 34.921 106.773 36.547 110.142 37.334 L 112.542 37.915 C 115.007 38.496 116.091 39.348 116.091 40.767 C 116.091 42.419 114.388 43.619 112.065 43.619 C 109.574 43.619 107.845 42.496 107.599 40.728 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 77.004 31.952 C 75.161 31.952 73.567 32.873 72.745 34.417 L 72.546 34.417 L 72.546 32.176 L 69.969 32.176 L 69.969 50.243 L 72.646 50.243 L 72.646 43.681 L 72.857 43.681 C 73.567 45.113 75.099 45.96 77.028 45.96 C 80.453 45.96 82.632 43.258 82.632 38.95 C 82.632 34.642 80.453 31.952 77.004 31.952 Z M 76.244 43.557 C 74.003 43.557 72.596 41.789 72.596 38.962 C 72.596 36.123 74.003 34.355 76.257 34.355 C 78.523 34.355 79.88 36.086 79.88 38.95 C 79.88 41.826 78.523 43.557 76.244 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 91.996 31.952 C 90.153 31.952 88.559 32.873 87.737 34.417 L 87.538 34.417 L 87.538 32.176 L 84.961 32.176 L 84.961 50.243 L 87.638 50.243 L 87.638 43.681 L 87.85 43.681 C 88.559 45.113 90.091 45.96 92.021 45.96 C 95.445 45.96 97.624 43.258 97.624 38.95 C 97.624 34.642 95.445 31.952 91.996 31.952 Z M 91.236 43.557 C 88.995 43.557 87.588 41.789 87.588 38.962 C 87.588 36.123 88.995 34.355 91.249 34.355 C 93.515 34.355 94.872 36.086 94.872 38.95 C 94.872 41.826 93.515 43.557 91.236 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.166 45.736 L 68.237 45.736 L 61.514 27.113 L 58.403 27.113 L 51.68 45.736 L 54.648 45.736 L 56.364 40.793 L 63.462 40.793 Z M 59.81 30.495 L 60.029 30.495 L 62.727 38.367 L 57.1 38.367 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 53.477 13.066 L 53.477 22.05 L 56.72 22.05 C 59.397 22.05 60.947 20.4 60.947 17.53 C 60.947 14.703 59.385 13.066 56.72 13.066 Z M 54.871 14.336 L 56.565 14.336 C 58.426 14.336 59.528 15.519 59.528 17.548 C 59.528 19.609 58.445 20.779 56.565 20.779 L 54.871 20.779 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.696 22.18 C 67.676 22.18 68.89 20.854 68.89 18.657 C 68.89 16.471 67.67 15.139 65.696 15.139 C 63.716 15.139 62.496 16.471 62.496 18.657 C 62.496 20.854 63.71 22.18 65.696 22.18 Z M 65.696 20.991 C 64.532 20.991 63.878 20.138 63.878 18.657 C 63.878 17.188 64.532 16.328 65.696 16.328 C 66.854 16.328 67.514 17.188 67.514 18.657 C 67.514 20.132 66.854 20.991 65.696 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 79.227 15.27 L 77.888 15.27 L 76.68 20.443 L 76.574 20.443 L 75.18 15.27 L 73.897 15.27 L 72.503 20.443 L 72.403 20.443 L 71.189 15.27 L 69.832 15.27 L 71.7 22.049 L 73.076 22.049 L 74.47 17.057 L 74.576 17.057 L 75.977 22.049 L 77.365 22.049 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 80.769 22.05 L 82.108 22.05 L 82.108 18.084 C 82.108 17.026 82.737 16.366 83.727 16.366 C 84.717 16.366 85.19 16.907 85.19 17.997 L 85.19 22.05 L 86.528 22.05 L 86.528 17.661 C 86.528 16.048 85.694 15.139 84.181 15.139 C 83.16 15.139 82.488 15.594 82.158 16.347 L 82.058 16.347 L 82.058 15.27 L 80.769 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 88.637 22.049 L 89.975 22.049 L 89.975 12.624 L 88.637 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 95.008 22.18 C 96.988 22.18 98.202 20.854 98.202 18.657 C 98.202 16.471 96.982 15.139 95.008 15.139 C 93.029 15.139 91.809 16.471 91.809 18.657 C 91.809 20.854 93.022 22.18 95.008 22.18 Z M 95.008 20.991 C 93.844 20.991 93.191 20.138 93.191 18.657 C 93.191 17.188 93.844 16.328 95.008 16.328 C 96.166 16.328 96.826 17.188 96.826 18.657 C 96.826 20.132 96.166 20.991 95.008 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 102.188 21.035 C 101.46 21.035 100.931 20.68 100.931 20.07 C 100.931 19.472 101.354 19.155 102.288 19.092 L 103.944 18.987 L 103.944 19.553 C 103.944 20.394 103.197 21.035 102.188 21.035 Z M 101.846 22.162 C 102.736 22.162 103.477 21.776 103.882 21.097 L 103.987 21.097 L 103.987 22.05 L 105.276 22.05 L 105.276 17.418 C 105.276 15.986 104.317 15.139 102.618 15.139 C 101.08 15.139 99.984 15.886 99.847 17.05 L 101.142 17.05 C 101.292 16.571 101.808 16.297 102.555 16.297 C 103.471 16.297 103.944 16.702 103.944 17.418 L 103.944 18.003 L 102.107 18.109 C 100.495 18.208 99.586 18.912 99.586 20.132 C 99.586 21.371 100.538 22.162 101.846 22.162 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 109.818 22.162 C 110.752 22.162 111.542 21.72 111.947 20.979 L 112.053 20.979 L 112.053 22.049 L 113.335 22.049 L 113.335 12.624 L 111.997 12.624 L 111.997 16.347 L 111.897 16.347 C 111.53 15.6 110.746 15.158 109.818 15.158 C 108.106 15.158 107.004 16.515 107.004 18.657 C 107.004 20.804 108.093 22.162 109.818 22.162 Z M 110.198 16.359 C 111.318 16.359 112.022 17.25 112.022 18.663 C 112.022 20.082 111.325 20.96 110.198 20.96 C 109.065 20.96 108.386 20.095 108.386 18.657 C 108.386 17.231 109.071 16.359 110.198 16.359 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 122.016 22.18 C 123.996 22.18 125.21 20.854 125.21 18.657 C 125.21 16.471 123.99 15.139 122.016 15.139 C 120.037 15.139 118.816 16.471 118.816 18.657 C 118.816 20.854 120.031 22.18 122.016 22.18 Z M 122.016 20.991 C 120.852 20.991 120.199 20.138 120.199 18.657 C 120.199 17.188 120.852 16.328 122.016 16.328 C 123.174 16.328 123.834 17.188 123.834 18.657 C 123.834 20.132 123.174 20.991 122.016 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 126.98 22.05 L 128.319 22.05 L 128.319 18.084 C 128.319 17.026 128.948 16.366 129.938 16.366 C 130.927 16.366 131.401 16.907 131.401 17.997 L 131.401 22.05 L 132.739 22.05 L 132.739 17.661 C 132.739 16.048 131.905 15.139 130.392 15.139 C 129.371 15.139 128.699 15.594 128.369 16.347 L 128.269 16.347 L 128.269 15.27 L 126.98 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 138.905 13.583 L 138.905 15.301 L 137.828 15.301 L 137.828 16.428 L 138.905 16.428 L 138.905 20.257 C 138.905 21.564 139.497 22.087 140.984 22.087 C 141.246 22.087 141.495 22.056 141.713 22.018 L 141.713 20.904 C 141.526 20.923 141.408 20.935 141.202 20.935 C 140.536 20.935 140.244 20.624 140.244 19.914 L 140.244 16.428 L 141.713 16.428 L 141.713 15.301 L 140.244 15.301 L 140.244 13.583 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.512 22.049 L 144.85 22.049 L 144.85 18.09 C 144.85 17.063 145.46 16.372 146.556 16.372 C 147.502 16.372 148.007 16.92 148.007 18.003 L 148.007 22.049 L 149.345 22.049 L 149.345 17.673 C 149.345 16.061 148.455 15.145 147.011 15.145 C 145.99 15.145 145.274 15.6 144.944 16.359 L 144.838 16.359 L 144.838 12.624 L 143.512 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 154.173 16.278 C 155.163 16.278 155.811 16.969 155.843 18.034 L 152.418 18.034 C 152.493 16.976 153.183 16.278 154.173 16.278 Z M 155.835 20.219 C 155.586 20.748 155.033 21.041 154.223 21.041 C 153.153 21.041 152.462 20.288 152.418 19.099 L 152.418 19.024 L 157.205 19.024 L 157.205 18.557 C 157.205 16.428 156.066 15.139 154.179 15.139 C 152.268 15.139 151.055 16.515 151.055 18.681 C 151.055 20.848 152.244 22.18 154.185 22.18 C 155.736 22.18 156.819 21.433 157.124 20.219 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 37.153 30.452 C 37.185 27.93 38.54 25.544 40.688 24.224 C 39.333 22.288 37.063 21.061 34.701 20.987 C 32.182 20.723 29.74 22.494 28.457 22.494 C 27.148 22.494 25.172 21.013 23.044 21.057 C 20.27 21.147 17.684 22.724 16.335 25.149 C 13.434 30.172 15.598 37.553 18.376 41.613 C 19.767 43.601 21.392 45.822 23.518 45.743 C 25.599 45.657 26.375 44.416 28.887 44.416 C 31.375 44.416 32.104 45.743 34.273 45.693 C 36.506 45.657 37.913 43.696 39.254 41.689 C 40.253 40.273 41.022 38.707 41.532 37.05 C 38.908 35.941 37.156 33.3 37.153 30.452 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 33.057 18.317 C 34.274 16.856 34.874 14.977 34.729 13.081 C 32.869 13.276 31.151 14.165 29.917 15.57 C 28.711 16.943 28.083 18.789 28.202 20.613 C 30.062 20.632 31.891 19.767 33.057 18.317 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg
            viewBox="0 0 201 58.5"
            overflow="visible"
            id="svg-412316951_7924"
          >
            <g>
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 159.651 44.25 L 162.45 44.25 L 162.45 25.498 L 159.651 25.498 Z M 184.862 32.253 L 181.654 40.383 L 181.558 40.383 L 178.228 32.253 L 175.213 32.253 L 180.208 43.616 L 177.359 49.937 L 180.278 49.937 L 187.975 32.253 Z M 168.988 42.12 C 168.073 42.12 166.793 41.661 166.793 40.528 C 166.793 39.08 168.386 38.525 169.76 38.525 C 170.99 38.525 171.571 38.79 172.318 39.152 C 172.1 40.89 170.605 42.12 168.988 42.12 Z M 169.326 31.843 C 167.3 31.843 165.201 32.736 164.333 34.714 L 166.817 35.751 C 167.348 34.714 168.336 34.376 169.374 34.376 C 170.822 34.376 172.293 35.244 172.317 36.789 L 172.317 36.981 C 171.81 36.692 170.724 36.258 169.398 36.258 C 166.719 36.258 163.994 37.729 163.994 40.479 C 163.994 42.989 166.19 44.605 168.65 44.605 C 170.531 44.605 171.57 43.761 172.22 42.771 L 172.317 42.771 L 172.317 44.22 L 175.02 44.22 L 175.02 37.029 C 175.02 33.7 172.533 31.843 169.326 31.843 Z M 152.029 34.536 L 148.047 34.536 L 148.047 28.108 L 152.029 28.108 C 154.121 28.108 155.309 29.84 155.309 31.322 C 155.309 32.775 154.121 34.536 152.029 34.536 Z M 151.957 25.498 L 145.249 25.498 L 145.249 44.25 L 148.047 44.25 L 148.047 37.146 L 151.957 37.146 C 155.059 37.146 158.108 34.9 158.108 31.322 C 158.108 27.744 155.059 25.498 151.957 25.498 Z M 115.384 42.124 C 113.45 42.124 111.832 40.504 111.832 38.282 C 111.832 36.033 113.45 34.391 115.384 34.391 C 117.293 34.391 118.791 36.033 118.791 38.282 C 118.791 40.504 117.293 42.124 115.384 42.124 Z M 118.598 33.303 L 118.501 33.303 C 117.873 32.554 116.664 31.877 115.142 31.877 C 111.952 31.877 109.028 34.681 109.028 38.282 C 109.028 41.858 111.952 44.637 115.142 44.637 C 116.664 44.637 117.873 43.96 118.501 43.187 L 118.598 43.187 L 118.598 44.105 C 118.598 46.546 117.293 47.851 115.19 47.851 C 113.475 47.851 112.412 46.618 111.977 45.579 L 109.536 46.594 C 110.236 48.285 112.097 50.364 115.19 50.364 C 118.478 50.364 121.257 48.431 121.257 43.718 L 121.257 32.264 L 118.598 32.264 Z M 123.19 44.25 L 125.992 44.25 L 125.992 25.498 L 123.19 25.498 Z M 130.125 38.064 C 130.053 35.599 132.035 34.342 133.46 34.342 C 134.572 34.342 135.514 34.898 135.829 35.695 Z M 138.824 35.937 C 138.293 34.512 136.674 31.877 133.363 31.877 C 130.076 31.877 127.346 34.463 127.346 38.257 C 127.346 41.834 130.053 44.637 133.677 44.637 C 136.601 44.637 138.293 42.849 138.994 41.81 L 136.819 40.359 C 136.094 41.423 135.104 42.124 133.677 42.124 C 132.252 42.124 131.236 41.471 130.585 40.19 L 139.114 36.662 Z M 70.863 33.835 L 70.863 36.541 L 77.339 36.541 C 77.146 38.064 76.638 39.175 75.865 39.949 C 74.922 40.891 73.448 41.93 70.863 41.93 C 66.875 41.93 63.758 38.716 63.758 34.729 C 63.758 30.742 66.875 27.527 70.863 27.527 C 73.013 27.527 74.584 28.373 75.744 29.461 L 77.654 27.551 C 76.034 26.005 73.884 24.821 70.863 24.821 C 65.4 24.821 60.809 29.268 60.809 34.729 C 60.809 40.19 65.4 44.637 70.863 44.637 C 73.81 44.637 76.034 43.67 77.774 41.858 C 79.562 40.069 80.118 37.556 80.118 35.526 C 80.118 34.898 80.069 34.318 79.973 33.835 Z M 87.481 42.124 C 85.547 42.124 83.88 40.529 83.88 38.257 C 83.88 35.961 85.547 34.391 87.481 34.391 C 89.414 34.391 91.081 35.961 91.081 38.257 C 91.081 40.529 89.414 42.124 87.481 42.124 Z M 87.481 31.877 C 83.952 31.877 81.077 34.56 81.077 38.257 C 81.077 41.93 83.952 44.637 87.481 44.637 C 91.009 44.637 93.885 41.93 93.885 38.257 C 93.885 34.56 91.009 31.877 87.481 31.877 Z M 101.45 42.124 C 99.518 42.124 97.85 40.529 97.85 38.257 C 97.85 35.961 99.518 34.391 101.45 34.391 C 103.384 34.391 105.051 35.961 105.051 38.257 C 105.051 40.529 103.384 42.124 101.45 42.124 Z M 101.45 31.877 C 97.922 31.877 95.047 34.56 95.047 38.257 C 95.047 41.93 97.922 44.637 101.45 44.637 C 104.979 44.637 107.855 41.93 107.855 38.257 C 107.855 34.56 104.979 31.877 101.45 31.877 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.965 19.102 C 64.62 19.102 63.463 18.628 62.531 17.696 C 61.598 16.763 61.125 15.594 61.125 14.236 C 61.125 12.877 61.598 11.711 62.531 10.776 C 63.463 9.843 64.62 9.37 65.965 9.37 C 66.65 9.37 67.289 9.489 67.9 9.735 C 68.512 9.981 69.012 10.324 69.406 10.771 L 69.498 10.877 L 68.449 11.926 L 68.345 11.797 C 68.083 11.476 67.751 11.227 67.33 11.046 C 66.911 10.865 66.452 10.781 65.965 10.781 C 65.018 10.781 64.232 11.103 63.575 11.757 C 62.933 12.424 62.611 13.236 62.611 14.236 C 62.611 15.236 62.934 16.049 63.576 16.716 C 64.232 17.37 65.018 17.693 65.965 17.693 C 66.832 17.693 67.549 17.451 68.113 16.972 C 68.638 16.526 68.953 15.923 69.064 15.155 L 65.815 15.155 L 65.815 13.772 L 70.469 13.772 L 70.489 13.898 C 70.527 14.142 70.554 14.376 70.554 14.602 C 70.554 15.892 70.16 16.945 69.389 17.72 C 68.517 18.644 67.372 19.102 65.965 19.102 Z M 106.377 19.102 C 105.031 19.102 103.887 18.628 102.967 17.696 C 102.967 17.696 102.966 17.696 102.966 17.695 C 102.044 16.773 101.587 15.605 101.587 14.236 C 101.587 12.867 102.044 11.699 102.966 10.777 C 102.966 10.776 102.966 10.776 102.966 10.776 C 103.886 9.844 105.031 9.37 106.377 9.37 C 107.722 9.37 108.865 9.844 109.786 10.79 C 110.708 11.712 111.166 12.878 111.166 14.236 C 111.166 15.605 110.708 16.773 109.786 17.695 C 108.865 18.628 107.711 19.102 106.377 19.102 Z M 71.886 18.9 L 71.886 9.572 L 72.036 9.572 L 77.457 9.572 L 77.457 10.983 L 73.346 10.983 L 73.346 13.545 L 77.054 13.545 L 77.054 14.927 L 73.346 14.927 L 73.346 17.491 L 77.457 17.491 L 77.457 18.9 Z M 80.866 18.9 L 80.866 10.983 L 78.344 10.983 L 78.344 9.572 L 84.848 9.572 L 84.848 10.983 L 84.698 10.983 L 82.326 10.983 L 82.326 18.9 Z M 89.005 18.9 L 89.005 9.572 L 90.465 9.572 L 90.465 9.722 L 90.465 18.9 Z M 94.141 18.9 L 94.141 10.983 L 91.619 10.983 L 91.619 9.572 L 98.123 9.572 L 98.123 10.983 L 97.973 10.983 L 95.601 10.983 L 95.601 18.9 Z M 112.462 18.9 L 112.462 9.572 L 114.108 9.572 L 118.299 16.28 L 118.263 15.007 L 118.263 9.572 L 119.723 9.572 L 119.723 18.9 L 118.278 18.9 L 113.886 11.853 L 113.922 13.125 L 113.922 13.127 L 113.922 18.9 Z M 106.377 17.693 C 107.325 17.693 108.098 17.37 108.728 16.717 L 108.729 16.716 L 108.73 16.715 C 109.369 16.076 109.682 15.252 109.682 14.236 C 109.682 13.222 109.369 12.396 108.73 11.757 L 108.729 11.756 L 108.728 11.755 C 108.098 11.102 107.325 10.781 106.377 10.781 C 105.428 10.781 104.655 11.102 104.013 11.754 L 104.013 11.755 C 103.385 12.41 103.073 13.222 103.073 14.236 C 103.073 15.252 103.385 16.062 104.013 16.717 C 104.655 17.37 105.429 17.693 106.377 17.693 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 30.322 28.385 L 14.352 45.335 C 14.353 45.338 14.354 45.341 14.354 45.345 C 14.844 47.185 16.525 48.541 18.52 48.541 C 19.318 48.541 20.067 48.325 20.709 47.946 L 20.76 47.916 L 38.736 37.544 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 46.48 25.499 L 46.465 25.489 L 38.704 20.99 L 29.961 28.77 L 38.735 37.542 L 46.455 33.088 C 47.808 32.358 48.727 30.931 48.727 29.285 C 48.727 27.652 47.82 26.232 46.48 25.499 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 14.349 13.165 C 14.253 13.519 14.203 13.89 14.203 14.275 L 14.203 44.226 C 14.203 44.611 14.253 44.983 14.35 45.335 L 30.869 28.819 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 30.441 29.25 L 38.706 20.987 L 20.751 10.576 C 20.098 10.185 19.336 9.96 18.521 9.96 C 16.526 9.96 14.843 11.317 14.353 13.16 C 14.352 13.162 14.352 13.163 14.352 13.165 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            id="svg864879421_410"
          >
            <path
              d="M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z"
              fill="#2F6BED"
              fillOpacity="0.1"
            />
            <path
              d="M26.6673 15L17.5007 24.1667L13.334 20"
              stroke="#2F6BED"
              strokeWidth={1.66667}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 256 256"
            id="svg-1208994263_271"
          >
            <path d="M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm45.66 85.66-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 11.32Z" />
          </svg>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            id="svg826821621_616"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
              fill="white"
            />
          </svg>
          <svg
            width="48"
            height="47"
            viewBox="0 0 48 47"
            fill="none"
            id="svg-705979310_561"
          >
            <path
              d="M47.9382 23.3454C47.9382 36.4095 37.037 47 23.9682 47C10.8994 47 0 36.4077 0 23.3454C0 10.283 10.9012 0 23.97 0C37.0389 0 47.94 10.2813 47.94 23.3454H47.9382Z"
              fill="url(#svg-705979310_561_paint0_linear_1441_10670)"
            />
            <defs>
              <linearGradient
                id="svg-705979310_561_paint0_linear_1441_10670"
                x1="45.0436"
                y1="3.13334"
                x2="-2.2064"
                y2="10.7229"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.48255" stopColor="#1C6BF5" />
                <stop offset="1" stopColor="#1E45B4" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="24"
            viewBox="0 0 20 24"
            fill="none"
            id="svg-583340053_1609"
          >
            <path
              d="M18.802 19.7673H17.4382C17.1321 19.7673 16.8827 20.0157 16.8827 20.3224V20.4981C16.8827 20.8049 16.6332 21.0532 16.3273 21.0532H3.41402C2.92055 21.0532 2.67293 20.4555 3.02133 20.1061L8.46609 14.6627H17.1675C17.2223 14.6627 17.2684 14.5404 17.2684 14.3896V12.7614C17.2684 12.6107 17.2241 12.4883 17.1675 12.4883H10.6419L11.6909 11.44C11.9085 11.2236 11.9085 10.8725 11.6909 10.6543L10.626 9.59012H17.1657C17.2206 9.59012 17.2665 9.4678 17.2665 9.31693V7.68873C17.2665 7.53798 17.2223 7.41566 17.1657 7.41566H8.45027L7.73555 6.70079L6.84937 5.81402L4.45594 3.42137C4.10578 3.07192 4.3534 2.4742 4.84863 2.4742H16.3255C16.6315 2.4742 16.881 2.72259 16.881 3.02939V3.20493C16.881 3.51184 17.1304 3.76188 17.4364 3.76188H18.8003C19.1063 3.76188 19.3557 3.5136 19.3557 3.20681V0.555187C19.3557 0.248277 19.1063 0 18.8003 0H0.557226C0.249491 0 0.00175685 0.248277 0.00175685 0.555187V2.47067L0.00539012 2.4742L3.34687 5.81402L4.23305 6.70079L4.94777 7.41566H2.19C2.13516 7.41566 2.0891 7.53798 2.0891 7.68873V9.31693C2.0891 9.4678 2.1334 9.59012 2.19 9.59012H7.12172L8.1866 10.6543C8.40422 10.8707 8.40422 11.2218 8.1866 11.44L7.13766 12.4883H2.19C2.13516 12.4883 2.0891 12.6107 2.0891 12.7614V14.3896C2.0891 14.5404 2.1334 14.6627 2.19 14.6627H4.96371L0.162773 19.4622C0.0583591 19.5669 0 19.707 0 19.8542V22.9723C0 23.2791 0.249492 23.5275 0.555469 23.5275H18.8003C19.1063 23.5275 19.3557 23.2791 19.3557 22.9723V20.3207C19.3557 20.0139 19.1063 19.7655 18.8003 19.7655L18.802 19.7673Z"
              fill="white"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-615147730_250"
          >
            <path
              d="M0 0H0.952739V3.52559L4.46836 0H5.81954L2.81836 2.91506L5.90274 7.23342H4.63125L2.10704 3.60443L0.952739 4.71234V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-145844853_1010"
          >
            <path
              d="M3.23555 3.31385C3.69375 3.31385 4.05586 3.22197 4.32071 3.03808C4.58907 2.85431 4.72383 2.52273 4.72383 2.04344C4.72383 1.52809 4.5375 1.17688 4.16367 0.989703C3.96445 0.891238 3.69727 0.842005 3.36328 0.842005H0.976172V3.31385H3.23555ZM0 0H3.33868C3.88829 0 4.3418 0.0804881 4.69922 0.241346C5.37657 0.549901 5.71524 1.11942 5.71524 1.94991C5.71524 2.38325 5.62618 2.73775 5.44571 3.01352C5.26875 3.2893 5.02031 3.51078 4.69922 3.67822C4.98047 3.79314 5.19141 3.94412 5.33321 4.1313C5.47617 4.31836 5.55704 4.62198 5.57344 5.04216L5.60743 6.01224C5.61797 6.28801 5.64024 6.49317 5.67656 6.62771C5.73516 6.85754 5.84063 7.00523 5.99063 7.07091V7.23342H4.79297C4.76016 7.17103 4.73321 7.09054 4.71446 6.99208C4.69453 6.89361 4.67813 6.70326 4.66524 6.4209L4.60547 5.21453C4.5832 4.74183 4.40742 4.42505 4.08047 4.26419C3.89414 4.1756 3.60117 4.1313 3.20157 4.1313H0.976172V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            id="svg-1278467936_878"
          >
            <path
              d="M3.4868 0C4.76028 0 5.70316 0.410309 6.31547 1.23105C6.79347 1.87119 7.03242 2.69016 7.03242 3.68809C7.03242 4.76815 6.75902 5.66585 6.21234 6.38154C5.57063 7.2219 4.65551 7.64208 3.46711 7.64208C2.35723 7.64208 1.48476 7.27443 0.849608 6.53911C0.28324 5.83 0 4.93382 0 3.85059C0 2.8724 0.242345 2.03534 0.726798 1.33938C1.34883 0.4465 2.26887 0 3.4868 0ZM3.585 6.76565C4.44597 6.76565 5.068 6.45698 5.45109 5.83987C5.83746 5.21947 6.03059 4.50718 6.03059 3.70289C6.03059 2.85266 5.80793 2.16823 5.36274 1.64958C4.92071 1.13094 4.31508 0.871615 3.54575 0.871615C2.79926 0.871615 2.19023 1.12929 1.71879 1.64465C1.24734 2.15671 1.01168 2.91341 1.01168 3.91463C1.01168 4.71563 1.21301 5.39184 1.61566 5.94327C2.02172 6.49152 2.67808 6.76565 3.585 6.76565Z"
              fill="black"
            />
          </svg>
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            id="svg-1222474147_282"
          >
            <path
              d="M1.06066 0L2.42098 5.88417L4.05141 0H5.11219L6.74262 5.88417L8.10293 0H9.17356L7.27793 7.23342H6.25149L4.58672 1.23598L2.91211 7.23342H1.88578L0 0H1.06066Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-185008150_190"
          >
            <path
              d="M5.85375 0V0.861745H3.42281V7.23342H2.43082V0.861745H0V0H5.85375Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg493993136_215"
          >
            <path
              d="M0 0H5.25961V0.886304H0.952734V3.0825H4.93547V3.91957H0.952734V6.37167H5.3332V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="6"
            height="8"
            viewBox="0 0 6 8"
            fill="none"
            id="svg-1085139225_208"
          >
            <path
              d="M0 0H1.15407L4.79789 5.85961V0H5.72602V7.23342H4.6309L0.933047 1.37875V7.23342H0V0Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg-1767852044_607"
          >
            <path
              d="M6.42188 9.32868L9.02579 0H12.532L8.20431 12.4382C7.3711 14.8361 6.71133 16.3212 6.225 16.8937C5.73985 17.4738 4.76719 17.7639 3.30938 17.7639C3.01641 17.7639 2.78086 17.76 2.60391 17.7523C2.42578 17.7523 2.15977 17.7406 1.80469 17.7175V15.072L2.22188 15.0952C2.54532 15.1107 2.85469 15.0991 3.14766 15.0604C3.44063 15.0217 3.68789 14.9327 3.88828 14.7935C4.08047 14.662 4.2586 14.3874 4.42032 13.9697C4.59024 13.5521 4.65938 13.2968 4.62891 13.2039L0 0H3.66797L6.42188 9.32868Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="14"
            viewBox="0 0 12 14"
            fill="none"
            id="svg1825421648_1004"
          >
            <path
              d="M11.7914 9.27063C11.707 10.0209 11.3168 10.7829 10.623 11.5564C9.54258 12.7862 8.03086 13.4012 6.08672 13.4012C4.48242 13.4012 3.0668 12.8829 1.83984 11.8465C0.61289 10.8099 0 9.12364 0 6.78762C0 4.5986 0.551956 2.91999 1.65469 1.75204C2.76563 0.583975 4.20469 0 5.9707 0C7.0207 0 7.96523 0.197283 8.80664 0.59173C9.64687 0.986178 10.3418 1.60893 10.8891 2.45974C11.3824 3.2101 11.7035 4.0803 11.85 5.07036C11.9344 5.65057 11.9695 6.486 11.9531 7.57663H3.32109C3.3668 8.84516 3.76407 9.73476 4.5129 10.2453C4.96758 10.5624 5.51602 10.7209 6.15587 10.7209C6.83555 10.7209 7.38633 10.5275 7.81055 10.1408C8.04258 9.93192 8.24649 9.64193 8.42461 9.27063H11.7914ZM8.52891 5.39525C8.47383 4.52117 8.20781 3.85988 7.72969 3.41126C7.25977 2.95489 6.67266 2.72659 5.9707 2.72659C5.20781 2.72659 4.61368 2.96641 4.18946 3.44604C3.77227 3.92556 3.50977 4.57533 3.40195 5.39525H8.52891Z"
              fill="black"
            />
          </svg>
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            id="svg-1693400435_567"
          >
            <path
              d="M5.91316 2.74985C4.79461 2.74985 4.02702 3.22549 3.61042 4.17701C3.39433 4.67979 3.2864 5.32181 3.2864 6.10307V12.9486H0V0.32477H3.18223V2.16964C3.60656 1.51986 4.00769 1.05198 4.38573 0.765747C5.0646 0.25521 5.92476 0 6.96621 0C8.27015 0 9.33421 0.344158 10.1604 1.03259C10.9936 1.71327 11.4096 2.84655 11.4096 4.43222V12.9486H8.03109V5.25601C8.03109 4.59072 7.94203 4.0803 7.76508 3.7244C7.44047 3.07474 6.82359 2.74985 5.91316 2.74985Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            id="svg2087326323_897"
          >
            <path
              d="M11.2942 2.00725C12.3588 3.34546 12.8911 4.92736 12.8911 6.75284C12.8911 8.60923 12.3588 10.1989 11.2942 11.5216C10.2295 12.8365 8.61341 13.4941 6.44555 13.4941C4.2777 13.4941 2.66156 12.8365 1.59692 11.5216C0.532267 10.1989 0 8.60923 0 6.75284C0 4.92736 0.532267 3.34546 1.59692 2.00725C2.66156 0.669163 4.2777 0 6.44555 0C8.61341 0 10.2295 0.669163 11.2942 2.00725ZM6.43395 2.79627C5.46961 2.79627 4.72524 3.14054 4.20059 3.82897C3.68368 4.50965 3.42528 5.48431 3.42528 6.75284C3.42528 8.02137 3.68368 8.99991 4.20059 9.68834C4.72524 10.3768 5.46961 10.7209 6.43395 10.7209C7.39828 10.7209 8.13891 10.3768 8.65583 9.68834C9.17274 8.99991 9.43114 8.02137 9.43114 6.75284C9.43114 5.48431 9.17274 4.50965 8.65583 3.82897C8.13891 3.14054 7.39828 2.79627 6.43395 2.79627Z"
              fill="black"
            />
          </svg>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            id="svg466797663_450"
          >
            <path
              d="M3.32109 17.1025H0V0H5.18425L8.2855 13.4476L11.3636 0H16.4899V17.1025H13.1688V5.53458C13.1688 5.20194 13.1727 4.73781 13.1804 4.1422C13.1882 3.53884 13.192 3.07474 13.192 2.74986L9.9634 17.1025H6.50344L3.29801 2.74986C3.29801 3.07474 3.30188 3.53884 3.30961 4.1422C3.31723 4.73781 3.32109 5.20194 3.32109 5.53458V17.1025Z"
              fill="black"
            />
          </svg>
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 18"
            fill="none"
            id="svg1460150476_230"
          >
            <path
              d="M11.7686 9.63028H3.48317V14.0277H12.9258V17.1025H0V0H12.5092V3.02833H3.48317V6.65999H11.7686V9.63028Z"
              fill="black"
            />
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
          <svg
            id="4128920373"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 0 3 C 0 1.343 1.343 0 3 0 C 4.657 0 6 1.343 6 3 C 6 4.657 4.657 6 3 6 C 1.343 6 0 4.657 0 3 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="6px"
              id="jOVwMWqOE"
              transform="translate(9 7.5)"
              width="6px"
            />
            <path
              d="M 0 0 L 3.375 0 L 3.375 3.375"
              fill="transparent"
              height="3.375px"
              id="Sc_lvRmtd"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(16.875 3.75)"
              width="3.375px"
            />
            <path
              d="M 0 3.375 L 3.375 3.375 L 3.375 0"
              fill="transparent"
              height="3.375px"
              id="uY5xKoxSW"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(16.875 16.875)"
              width="3.375px"
            />
            <path
              d="M 3.375 3.375 L 0 3.375 L 0 0"
              fill="transparent"
              height="3.375px"
              id="jFAqhvVNI"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 16.875)"
              width="3.375px"
            />
            <path
              d="M 3.375 0 L 0 0 L 0 3.375"
              fill="transparent"
              height="3.375px"
              id="akXBKapaV"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3.75 3.75)"
              width="3.375px"
            />
            <path
              d="M 0 3 C 0 1.343 1.343 0 3 0 C 4.657 0 6 1.343 6 3 C 6 4.657 4.657 6 3 6 C 1.343 6 0 4.657 0 3 Z"
              fill="transparent"
              height="6px"
              id="FuiANUKXv"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(9 7.5)"
              width="6px"
            />
            <path
              d="M 0 2.25 C 1.062 0.834 2.729 0 4.5 0 C 6.271 0 7.938 0.834 9 2.25"
              fill="transparent"
              height="2.25px"
              id="QPUzbP_h_"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(7.5 13.5)"
              width="9px"
            />
          </svg>
          <svg
            id="2758010082"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 0 1.238 L 0 12.488 C 8.591 8.291 12.409 16.459 21 12.261 L 21 1.011 C 12.409 5.209 8.591 -2.959 0 1.238 Z M 10.5 9 C 9.257 9 8.25 7.993 8.25 6.75 C 8.25 5.507 9.257 4.5 10.5 4.5 C 11.743 4.5 12.75 5.507 12.75 6.75 C 12.75 7.993 11.743 9 10.5 9 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="13.49980803904471px"
              id="MMpbaZYMI"
              transform="translate(1.5 5.25)"
              width="21px"
            />
            <path
              d="M 21 12.261 C 12.409 16.459 8.591 8.291 0 12.488 L 0 1.238 C 8.591 -2.959 12.409 5.209 21 1.011 Z"
              fill="transparent"
              height="13.499808039044709px"
              id="Ev5IwXLVx"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(1.5 5.25)"
              width="21px"
            />
            <path
              d="M 0 2.25 C 0 1.007 1.007 0 2.25 0 C 3.493 0 4.5 1.007 4.5 2.25 C 4.5 3.493 3.493 4.5 2.25 4.5 C 1.007 4.5 0 3.493 0 2.25 Z"
              fill="transparent"
              height="4.5px"
              id="WU8V3C5z1"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(9.75 9.75)"
              width="4.5px"
            />
            <path
              d="M 0 0 L 0 4.5"
              fill="transparent"
              height="4.5px"
              id="WzT7hSez7"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(4.5 9)"
              width="1px"
            />
            <path
              d="M 0 0 L 0 4.5"
              fill="transparent"
              height="4.5px"
              id="mIpN_pvvr"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(19.5 10.5)"
              width="1px"
            />
          </svg>
          <svg
            id="1485826237"
            display="block"
            role="presentation"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M 9 9 C 10.657 9 12 7.657 12 6 L 18 6 L 18 1.5 C 18 0.672 17.328 0 16.5 0 L 1.5 0 C 0.672 0 0 0.672 0 1.5 L 0 6 L 6 6 C 6 7.657 7.343 9 9 9 Z"
              fillOpacity="var(--1m6trwb, 0)"
              fill="var(--21h8s6, rgb(0, 0, 0))"
              height="9px"
              id="BE4Ujn7Fq"
              transform="translate(3 5.25)"
              width="18px"
            />
            <path
              d="M 1.5 13.5 C 0.672 13.5 0 12.828 0 12 L 0 1.5 C 0 0.672 0.672 0 1.5 0 L 16.5 0 C 17.328 0 18 0.672 18 1.5 L 18 12 C 18 12.828 17.328 13.5 16.5 13.5 Z"
              fill="transparent"
              height="13.5px"
              id="M_SbNMzRq"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3 5.25)"
              width="18px"
            />
            <path
              d="M 0 0 L 6 0 C 6 1.657 7.343 3 9 3 C 10.657 3 12 1.657 12 0 L 18 0"
              fill="transparent"
              height="3px"
              id="yibtMa4ae"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3 11.25)"
              width="18px"
            />
            <path
              d="M 0 0 L 18 0"
              fill="transparent"
              height="1px"
              id="BrDOA4Bax"
              strokeDasharray=""
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="var(--pgex8v, 1.5)"
              stroke="var(--21h8s6, rgb(0, 0, 0))"
              transform="translate(3 8.25)"
              width="18px"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-GjyFL framer-rcOGl framer-tx7Wz framer-5xTxc framer-1c849rx home-s1"
        >
          <div className="ssr-variant hidden-1kqrdcg">
            <div
              className="framer-yzzwb1-container home-s2"
              data-framer-appear-id="yzzwb1"
              id="yzzwb1"
            >
              <div className="ssr-variant hidden-15k5156">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15zawlh home-s3"
                  data-framer-name="Desktop [Default Boxed]"
                >
                  <header
                    className="framer-ooxjtq home-s4"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 home-s5"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 home-s6"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a
                        className="framer-1jy87r1 framer-145ct8v"
                        href="/"
                        data-framer-page-link-current="true"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz home-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz home-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpdesk"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 home-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm home-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze home-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text home-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
              <div className="ssr-variant hidden-1c849rx">
                <div
                  className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 home-s3"
                  data-framer-name="Desktop [Boxed Mini]"
                >
                  <header
                    className="framer-ooxjtq home-s17"
                    data-border="true"
                    data-framer-name="Main Area"
                  >
                    <div
                      className="framer-p578i7 home-s6"
                      data-framer-name="Background [Default]"
                    />
                    <div
                      className="framer-pc27k4 home-s5"
                      data-framer-name="Background [Boxed Mini]"
                    />
                    <div className="framer-cjwofg" data-framer-name="Content">
                      {/*$*/}
                      <a
                        className="framer-1jy87r1 framer-145ct8v"
                        href="/"
                        data-framer-page-link-current="true"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1hjthz home-s7"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                      <nav className="framer-xe9vp0" data-framer-name="Nav">
                        <div
                          className="framer-1hg3ikx-container"
                          data-framer-name="Menu [Desktop]"
                          name="Menu [Desktop]"
                        >
                          <div
                            name="Menu [Desktop]"
                            className="framer-n0D3w framer-1itjusz framer-v-1itjusz home-s8"
                            data-framer-name="Menu"
                          >
                            {/*$*/}
                            <div className="framer-mquu2a-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/accounts"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Accounts{' '}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1yixouk-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-pay"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Scallop Pay
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-wi7xty-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/cards"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Cards
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1tpzm7c-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/scallop-plus"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    Scallop+
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-u2qi4r-container">
                              {/*$*/}
                              <a
                                className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq home-s9"
                                data-framer-name="Menu Item Simple"
                                data-highlight="true"
                                href="/helpdesk"
                                tabIndex={0}
                              >
                                <div
                                  className="framer-19g30xi home-s10 reveal"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s11"
                                  >
                                    FAQs
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                      </nav>
                      <div
                        className="framer-14uxsxw"
                        data-framer-name="Menu Icon"
                      >
                        <div
                          className="framer-16051d2"
                          data-framer-name="QR Overlay Trigger"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-168591e-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 home-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm home-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze home-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text home-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-1c849rx hidden-15k5156">
            <div
              className="framer-yzzwb1-container"
              data-framer-appear-id="yzzwb1"
              id="yzzwb1"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l home-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq home-s18"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 home-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 home-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a
                      className="framer-1jy87r1 framer-145ct8v"
                      href="/"
                      data-framer-page-link-current="true"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz home-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi home-s19"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                          role="button"
                          aria-label="Toggle menu"
                        >
                          <div className="framer-1cux5of home-s20" />
                          <div className="framer-1w1bul6 home-s20" />
                          <div className="framer-1ku2ucf home-s21" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-1bf90a0" data-framer-name="container">
            <div
              className="framer-i8qbm7"
              data-framer-name="hero section"
              id="i8qbm7"
            >
              <div className="framer-ht682t" data-framer-name="Hero Text">
                <div className="framer-1o80xff" data-framer-name="Text">
                  <div className="framer-1uwar5j">
                    <div
                      className="framer-1txlnm8 reveal"
                      data-framer-appear-id="1txlnm8"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h1
                        className="framer-text framer-styles-preset-18sajzf home-s22"
                        data-styles-preset="nXmNeSqma"
                        dir="auto"
                      >
                        One account.
                      </h1>
                    </div>
                    <div
                      className="framer-1dcy3y0 reveal"
                      data-framer-appear-id="1dcy3y0"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h1
                        className="framer-text framer-styles-preset-18sajzf home-s23"
                        data-styles-preset="nXmNeSqma"
                        dir="auto"
                      >
                        Any currency. Anywhere.
                      </h1>
                    </div>
                  </div>
                  <div
                    className="framer-1tm1f6f reveal"
                    data-framer-appear-id="1tm1f6f"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s24">
                      Move money across 52+ currencies and digital assets,{' '}
                      <br className="framer-text" />
                      all in one unified balance, in 120+ countries.
                    </p>
                  </div>
                  <div className="ssr-variant hidden-1kqrdcg">
                    {/*$*/}
                    <a
                      className="framer-1fwgczm framer-7gedj2 home-s25"
                      data-border="true"
                      data-framer-appear-id="1fwgczm"
                      data-framer-name="Badge"
                      id="1fwgczm"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                      tabIndex={0}
                    >
                      <div className="framer-l6kdce home-s26" />
                      <div className="framer-1p4gf0c" data-framer-name="Badge">
                        <div
                          className="framer-1280rhf"
                          data-framer-name="_Badge base"
                        >
                          <div
                            className="framer-cwhcjs home-s27 reveal"
                            data-framer-name="Text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s28">
                              Now live
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-13nnik9"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-d5xsek home-s27 reveal"
                          data-framer-name="Message"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text home-s29">
                            Create your account
                          </p>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="arrow-right"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-f4sc60 home-s30"
                          aria-hidden="true"
                        />
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                  <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                    {/*$*/}
                    <a
                      className="framer-1fwgczm framer-7gedj2 home-s25"
                      data-border="true"
                      data-framer-appear-id="1fwgczm"
                      data-framer-name="Badge"
                      id="1fwgczm"
                      href="https://onelink.to/wch597"
                      target="_blank"
                      rel="noopener"
                    >
                      <div className="framer-l6kdce home-s26" />
                      <div className="framer-1p4gf0c" data-framer-name="Badge">
                        <div
                          className="framer-1280rhf"
                          data-framer-name="_Badge base"
                        >
                          <div
                            className="framer-cwhcjs home-s27 reveal"
                            data-framer-name="Text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s28">
                              Now live
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-13nnik9"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-d5xsek home-s27 reveal"
                          data-framer-name="Message"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text home-s29">
                            Create your account
                          </p>
                        </div>
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="arrow-right"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-f4sc60 home-s30"
                          aria-hidden="true"
                        />
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
              <div
                className="framer-e7mn0m"
                data-framer-name="iPhone 16 Pro mockup black titanium bottom"
              >
                <div className="ssr-variant">
                  <div className="framer-14ckad6" data-framer-name="main">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        width="1572"
                        height="2048"
                        sizes="(min-width: 1440px) 636px, (max-width: 809.98px) 239px, (min-width: 810px) and (max-width: 1439.98px) 465px"
                        srcSet="/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png 785w,/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png 1572w"
                        src="/framerusercontent.com/images/jwD9OZUhFM1jb1RRdXwuygrrQWk.png"
                        alt=""
                        className="home-s32"
                      />
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-lixol"
                    data-framer-name="iPhone 16 Pro mockup black titanium bottom label"
                  >
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        width="2964"
                        height="3797"
                        sizes="(min-width: 1440px) 600px, (max-width: 809.98px) 225px, (min-width: 810px) and (max-width: 1439.98px) 439px"
                        srcSet="/framerusercontent.com/images/rdVRRPHKVQnoR76zHoYsdpoB6A.png 799w,/framerusercontent.com/images/rdVRRPHKVQnoR76zHoYsdpoB6A.png 1598w,/framerusercontent.com/images/rdVRRPHKVQnoR76zHoYsdpoB6A.png 2964w"
                        src="/framerusercontent.com/images/rdVRRPHKVQnoR76zHoYsdpoB6A.png"
                        alt=""
                        className="home-s32"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-39lztg">
                <div
                  className="framer-1cfiuwp hidden-1kqrdcg"
                  data-framer-appear-id="1cfiuwp"
                  data-framer-name="Float_Tag_Amazon"
                >
                  <div
                    className="framer-1csmabf"
                    data-framer-name="Rectangle 474"
                  >
                    <div className="framer-hfv8ig" data-framer-name="Currency">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame 1437256546"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-cqrkl4 home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 40 40" className="home-s35">
                            <use href="#svg-726352421_1977" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1iq9fkp"
                      data-framer-name="Frame 1437256476"
                    >
                      <div
                        className="framer-bz8n7h home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p className="framer-text home-s36">
                          $50 Sent to Amazon
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-rcn08f hidden-1kqrdcg"
                  data-framer-appear-id="rcn08f"
                  data-framer-name="Arrow"
                >
                  <div className="framer-1o1og5m" data-framer-name="Arrow">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Group"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-k4jdpe home-s37"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 52 56" className="home-s35">
                          <use href="#svg764373717_1237" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-15k5156">
                  <div
                    className="framer-lbie5i hidden-1kqrdcg home-s38 reveal"
                    data-framer-name="Shop, Spend,   Swap Smartly!"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s39">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">h</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">p</span>
                        <span className="home-s41">,</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">p</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">d</span>
                        <span className="home-s41">,</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s39">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">w</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">p</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">m</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">y</span>
                        <span className="home-s41">!</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-lbie5i hidden-1kqrdcg home-s38 reveal"
                    data-framer-name="Shop, Spend,   Swap Smartly!"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s42">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">h</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">p</span>
                        <span className="home-s41">,</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">p</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">d</span>
                        <span className="home-s41">,</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p dir="auto" className="framer-text home-s42">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">w</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">p</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">m</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">y</span>
                        <span className="home-s41">!</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className="framer-1wla2xe"
                  data-framer-appear-id="1wla2xe"
                  data-framer-name="Float_Tag_Multipurporpose"
                >
                  <div
                    className="framer-9zrykf"
                    data-framer-name="Rectangle 474"
                  >
                    <div className="framer-12z0v0q" data-framer-name="Currency">
                      <div className="ssr-variant">
                        <div
                          className="framer-bxjpgg home-s43"
                          data-framer-name="Virtual Card"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="885"
                              height="552"
                              sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 48.3514px, (max-width: 809.98px) 23.55px"
                              srcSet="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 512w,/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png 885w"
                              src="/framerusercontent.com/images/oChaGuv2eWzmbdEoprHAowKXvk.png"
                              alt=""
                              className="home-s44"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="ssr-variant">
                        <div
                          className="framer-10kfl47 home-s45"
                          data-framer-name="Virtual Card"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="885"
                              height="552"
                              sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 48.3514px, (max-width: 809.98px) 23.55px"
                              srcSet="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 512w,/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png 885w"
                              src="/framerusercontent.com/images/4MbGAMowPoEYJyKAQBNYWjX18pA.png"
                              alt=""
                              className="home-s44"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="ssr-variant">
                        <div
                          className="framer-4af69e home-s46"
                          data-framer-name="Virtual Card"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="885"
                              height="552"
                              sizes="(min-width: 1440px) 48.3514px, (min-width: 810px) and (max-width: 1439.98px) 48.3514px, (max-width: 809.98px) 23.55px"
                              srcSet="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 512w,/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png 885w"
                              src="/framerusercontent.com/images/Al29K69qKBrzvyAHVyF0tWhfo30.png"
                              alt=""
                              className="home-s44"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1hos4kp"
                    data-framer-name="Frame 1437256476"
                  >
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-1hc00x6 home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s36">
                          Virtual Cards
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-1hc00x6 home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s47">
                          Virtual Cards
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-ji6rda"
                  data-framer-appear-id="ji6rda"
                  data-framer-name="Arrow"
                >
                  <div className="framer-1wggk47" data-framer-name="Arrow">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Group"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1dvh8os home-s37"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 52 56" className="home-s35">
                          <use href="#svg764373717_1237" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-hpwy80"
                  data-framer-appear-id="hpwy80"
                  data-framer-name="Float_Tag_GBP"
                >
                  <div
                    className="framer-laf3fp"
                    data-framer-name="Rectangle 474"
                  />
                  <div
                    className="framer-1ew85om"
                    data-framer-name="Frame 1437256476"
                  >
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-1y8keew home-s27 reveal"
                        data-framer-name="GBP Balance"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s48">
                          USD Balance
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-1y8keew home-s27 reveal"
                        data-framer-name="GBP Balance"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s49">
                          USD Balance
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                      <div
                        className="framer-lzb1it home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s50">
                          $900
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-lzb1it home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s47">
                          $900
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                      <div
                        className="framer-lzb1it home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s51">
                          $900
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-ex16za" data-framer-name="Currency">
                    <div
                      className="framer-194qgo9"
                      data-framer-name="Ellipse 133"
                    />
                    <div className="framer-1duedbj" data-framer-name="Avtar">
                      <div className="ssr-variant">
                        <div
                          className="framer-u94ysr"
                          data-framer-name="Currency"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="204"
                              height="204"
                              src="/framerusercontent.com/images/XZ3bQjqJx8pMohQFIkYYkUzei0.png"
                              alt=""
                              className="home-s52"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1ybbx9p"
                    data-framer-name="Group 1437256544"
                  >
                    <div
                      className="framer-axy9jw"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-1jsot28" data-framer-name="bank">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-4mbzqh home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 14 14" className="home-s35">
                              <use href="#svg-738554790_445" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-7satdf home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 14 7" className="home-s35">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1w8f2p1"
                  data-framer-appear-id="1w8f2p1"
                  data-framer-name="Float_Tag_GBP"
                >
                  <div
                    className="framer-1arp3z5"
                    data-framer-name="Rectangle 474"
                  />
                  <div
                    className="framer-w6splg"
                    data-framer-name="Frame 1437256476"
                  >
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-fj2un2 home-s27 reveal"
                        data-framer-name="GBP Balance"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s48">
                          EUR Balance
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-fj2un2 home-s27 reveal"
                        data-framer-name="GBP Balance"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s49">
                          EUR Balance
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                      <div
                        className="framer-pcpx4r home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s50">
                          &euro;516
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-pcpx4r home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s47">
                          &euro;516
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                      <div
                        className="framer-pcpx4r home-s27 reveal"
                        data-framer-name="98,269 \xA3"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s51">
                          &euro;516
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-pwm8m3" data-framer-name="Currency">
                    <div
                      className="framer-szmd47"
                      data-framer-name="Ellipse 133"
                    />
                    <div className="framer-1iut78u" data-framer-name="Avtar">
                      <div className="ssr-variant hidden-1kqrdcg">
                        <div
                          className="framer-leogr home-s53"
                          data-framer-name="image 1578"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="592"
                              height="592"
                              sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 33.34px"
                              srcSet="/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png 512w,/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png 592w"
                              src="/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png"
                              alt=""
                              className="home-s44"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                        <div
                          className="framer-leogr"
                          data-framer-name="image 1578"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="592"
                              height="592"
                              sizes="(min-width: 1440px) 83px, (min-width: 810px) and (max-width: 1439.98px) 83px, (max-width: 809.98px) 33.34px"
                              srcSet="/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png 512w,/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png 592w"
                              src="/framerusercontent.com/images/VNINYViTeRN4qEQ3ROaXvNPcIT4.png"
                              alt=""
                              className="home-s44"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1tj9bd2"
                    data-framer-name="Group 1437256544"
                  >
                    <div
                      className="framer-tlz5b2"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-74xcd8" data-framer-name="bank">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-y5xqim home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 14 14" className="home-s35">
                              <use href="#svg-738554790_445" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hzs4q1 home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 14 7" className="home-s35">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-g6ej66 hidden-1c849rx hidden-15k5156"
                  data-framer-appear-id="g6ej66"
                  data-framer-name="Float_Tag_GBP"
                >
                  <div
                    className="framer-1rofavv"
                    data-framer-name="Rectangle 474"
                  />
                  <div
                    className="framer-1qvkbuo"
                    data-framer-name="Frame 1437256476"
                  >
                    <div
                      className="framer-1nhsfks home-s27 reveal"
                      data-framer-name="GBP Balance"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s49">
                        USDC Balance
                      </p>
                    </div>
                    <div
                      className="framer-1g8b6jj home-s27 reveal"
                      data-framer-name="98,269 \xA3"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s47">
                        &euro;25,525
                      </p>
                    </div>
                  </div>
                  <div className="framer-16btcu6" data-framer-name="Currency">
                    <div
                      className="framer-38nynn"
                      data-framer-name="Ellipse 133"
                    />
                    <div className="framer-jfxn41" data-framer-name="Avtar">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Usdc 1"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-onk5hn home-s54"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                  <div
                    className="framer-va55l9"
                    data-framer-name="Group 1437256544"
                  >
                    <div
                      className="framer-4ufqm9"
                      data-border="true"
                      data-framer-name="Ellipse 14984"
                    >
                      <div className="framer-18h7xcw" data-framer-name="bank">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Vector"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1nvpnmz home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 14 14" className="home-s35">
                              <use href="#svg-738554790_445" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-nqhy90 home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 14 7" className="home-s35">
                            <use href="#svg95803052_220" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-jjt1r7"
                    data-framer-appear-id="jjt1r7"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-17q98aq" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-x9kbzz home-s55"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 59 61" className="home-s35">
                            <use href="#svg147118731_1233" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                  <div
                    className="framer-178y2s8 home-s56 reveal"
                    data-framer-name="Multicarrecy account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">M</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">i</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">a</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-178y2s8 home-s56 reveal"
                    data-framer-name="Multicarrecy account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s58">
                      <span className="home-s40">
                        <span className="home-s41">M</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">i</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s58">
                      <span className="home-s40">
                        <span className="home-s41">a</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-178y2s8 home-s59 reveal"
                    data-framer-name="Multicarrecy account"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">M</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">i</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">a</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">u</span>
                        <span className="home-s41">n</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className="framer-1lttvbk hidden-1kqrdcg"
                  data-framer-appear-id="1lttvbk"
                  data-framer-name="Float_Tag_BTC"
                >
                  <div
                    className="framer-1xam3v8"
                    data-framer-name="Rectangle 474"
                  />
                  <div
                    className="framer-7qurrf"
                    data-framer-name="Frame 1437256476"
                  >
                    <div
                      className="framer-ojzvc1 home-s27 reveal"
                      data-framer-name="BTC Balance"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s48">
                        USDC Balance
                      </p>
                    </div>
                    <div className="ssr-variant hidden-15k5156">
                      <div
                        className="framer-15dxe1u home-s27 reveal"
                        data-framer-name="0.908 BTC"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s50">
                          $800
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                      <div
                        className="framer-15dxe1u home-s27 reveal"
                        data-framer-name="0.908 BTC"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text home-s60">
                          $800
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-18pm81u"
                    data-framer-name="Cryptocurrency icon/Bitcoin"
                  >
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Usdc 1"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-463b0r home-s61"
                      aria-hidden="true"
                    />
                  </div>
                  <div
                    className="framer-179n6z"
                    data-border="true"
                    data-framer-name="Ellipse 14984"
                  >
                    <div className="framer-pu2pgw" data-framer-name="bank" />
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Vector"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-10h7btz home-s33"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 14 7" className="home-s35">
                          <use href="#svg95803052_220" />
                        </svg>
                      </div>
                    </div>
                    <div className="framer-1b4g3za" data-framer-name="wallet2">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1xt4alx home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 14 11" className="home-s35">
                            <use href="#svg-212988539_408" />
                          </svg>
                        </div>
                      </div>
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Vector"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-163wda home-s33"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 14 14" className="home-s35">
                            <use href="#svg-1448888000_2617" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-i969y3"
                    data-framer-appear-id="i969y3"
                    data-framer-name="Arrow"
                  >
                    <div className="framer-cyheru" data-framer-name="Arrow">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Group"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-lsohbr home-s55"
                        aria-hidden="true"
                      >
                        <div className="svgContainer home-s34">
                          <svg viewBox="0 0 59 61" className="home-s35">
                            <use href="#svg147118731_1233" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                  <div
                    className="framer-3e5hds home-s62 reveal"
                    data-framer-name="Crypto   wallets"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s63">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">b</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">i</span>
                        <span className="home-s41">n</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p dir="auto" className="framer-text home-s63">
                      <span className="home-s40">
                        <span className="home-s41">w</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-3e5hds home-s62 reveal"
                    data-framer-name="Crypto   wallets"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s64">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">b</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">i</span>
                        <span className="home-s41">n</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p dir="auto" className="framer-text home-s64">
                      <span className="home-s40">
                        <span className="home-s41">w</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-3e5hds home-s65 reveal"
                    data-framer-name="Crypto   wallets"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s63">
                      <span className="home-s40">
                        <span className="home-s41">S</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">b</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">c</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">i</span>
                        <span className="home-s41">n</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p dir="auto" className="framer-text home-s63">
                      <span className="home-s40">
                        <span className="home-s41">w</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">l</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">t</span>
                        <span className="home-s41">s</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                  <div
                    className="framer-1q31bpw home-s27 reveal"
                    data-framer-name="A card for every need"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">A</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">d</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">f</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">r</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">e</span>
                        <span className="home-s41">v</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">n</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">d</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-1q31bpw home-s62 reveal"
                    data-framer-name="A card for every need"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s66">
                      <span className="home-s40">
                        <span className="home-s41">A</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">d</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">f</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">r</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p dir="auto" className="framer-text home-s66">
                      <span className="home-s40">
                        <span className="home-s41">e</span>
                        <span className="home-s41">v</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">n</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">d</span>
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-1q31bpw home-s62 reveal"
                    data-framer-name="A card for every need"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">A</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">c</span>
                        <span className="home-s41">a</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">d</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">f</span>
                        <span className="home-s41">o</span>
                        <span className="home-s41">r</span>
                      </span>{' '}
                      <span className="home-s40" />
                    </p>
                    <p className="framer-text home-s57">
                      <span className="home-s40">
                        <span className="home-s41">e</span>
                        <span className="home-s41">v</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">r</span>
                        <span className="home-s41">y</span>
                      </span>{' '}
                      <span className="home-s40">
                        <span className="home-s41">n</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">e</span>
                        <span className="home-s41">d</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1w1rw0w" data-framer-name="downloads links">
              <div className="framer-w8r3zp">
                {/*$*/}
                <a
                  className="framer-1g4j6bj framer-7gedj2"
                  data-framer-name="Appstore"
                  href="https://apps.apple.com/app/scallop/id6746711366"
                  target="_blank"
                  rel="noopener"
                >
                  <div
                    data-framer-component-type="SVG"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-k7b54d home-s67"
                    aria-hidden="true"
                  >
                    <div className="svgContainer home-s34">
                      <svg className="home-s68">
                        <use href="#svg1322499166_10645" />
                      </svg>
                    </div>
                  </div>
                </a>
                {/*/$*/}
                {/*$*/}
                <a
                  className="framer-irtpbo framer-7gedj2"
                  data-framer-name="Playstore"
                  href="https://play.google.com/store/apps/details?id=com.app.scallop"
                  target="_blank"
                  rel="noopener"
                >
                  <div
                    data-framer-component-type="SVG"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-1o0ohww home-s67"
                    aria-hidden="true"
                  >
                    <div className="svgContainer home-s34">
                      <svg className="home-s68">
                        <use href="#svg-412316951_7924" />
                      </svg>
                    </div>
                  </div>
                </a>
                {/*/$*/}
              </div>
            </div>
            <div
              className="framer-1pmbyko home-s25"
              data-framer-name="core value"
            >
              <div className="framer-1ma287c" data-framer-name="title">
                <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                  <div
                    className="framer-b4reqf reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw home-s23"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Built for how money actually
                      <br className="framer-text" />
                      moves
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-b4reqf home-s69 reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text home-s70">
                      Built for how money actually
                      <br className="framer-text" />
                      moves
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-b4reqf reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw home-s23"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Built for how money actually moves
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg">
                  <div
                    className="framer-2iejvf reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s71">
                      Earn in one currency. Hold in another. Spend anywhere. One
                      account for fiat, stablecoins, and digital assets, no
                      switching, no friction.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-2iejvf reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s72">
                      Earn in one currency. Hold in another. Spend anywhere. One
                      account for fiat, stablecoins, and digital assets, no
                      switching, no friction.
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-b38mmi">
                <div
                  className="framer-1nyqd"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-v3b4br home-s33"
                    aria-hidden="true"
                  >
                    <div className="svgContainer home-s34">
                      <svg viewBox="0 0 40 40" className="home-s35">
                        <use href="#svg864879421_410" />
                      </svg>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-15k5156">
                    <div
                      className="framer-1a2suo3 home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s73">
                        One app for fiat and digital assets
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                    <div
                      className="framer-1a2suo3 home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s74">
                        One app for fiat and digital assets
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-vupoof"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-hbba42 home-s33"
                    aria-hidden="true"
                  >
                    <div className="svgContainer home-s34">
                      <svg viewBox="0 0 40 40" className="home-s35">
                        <use href="#svg864879421_410" />
                      </svg>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-15k5156">
                    <div
                      className="framer-4vksdt home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s73">
                        Convert, send, and spend in one flow
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                    <div
                      className="framer-4vksdt home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s74">
                        Convert, send, and spend in one flow
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1h6s6ye"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-18yy6fa home-s33"
                    aria-hidden="true"
                  >
                    <div className="svgContainer home-s34">
                      <svg viewBox="0 0 40 40" className="home-s35">
                        <use href="#svg864879421_410" />
                      </svg>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-15k5156">
                    <div
                      className="framer-12ha3fa home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s73">
                        No switching between apps or balances
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                    <div
                      className="framer-12ha3fa home-s27 reveal"
                      data-framer-name="Convert, send, and spend in one flow"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text home-s74">
                        No switching between apps or balances
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1kqrdcg">
              <div
                className="framer-15pykd3"
                data-framer-appear-id="15pykd3"
                data-framer-name="Features"
              >
                <div className="framer-jo3t4p" data-framer-name="Text">
                  <div className="ssr-variant hidden-15k5156">
                    <div
                      className="framer-1ny0wxj reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2
                        className="framer-text framer-styles-preset-120m1vw home-s23"
                        data-styles-preset="Sp_YUSQNX"
                        dir="auto"
                      >
                        Everything runs from one account
                      </h2>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1c849rx">
                    <div
                      className="framer-1ny0wxj reveal"
                      data-framer-name="Heading"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text home-s75">
                        Everything runs from one account
                      </h2>
                    </div>
                  </div>
                  <div
                    className="framer-tw9sh2 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s71">
                      Full access to core features across 120+ countries. No
                      regional limitations on how you use your money.
                    </p>
                  </div>
                </div>
                <div className="framer-kn2r9h" data-framer-name="Features">
                  <div
                    className="framer-bnjmvr home-s69"
                    data-border="true"
                    data-framer-name="Feature 1"
                  >
                    <div className="ssr-variant">
                      <div className="framer-iavqgc-container">
                        {/*$*/}
                        <a
                          className="framer-2pnTs framer-1mbqquk framer-v-1mbqquk framer-19sfakh home-s76"
                          data-framer-name="Desktop Style 1"
                          href="/accounts"
                        >
                          <div
                            className="framer-1682k4t"
                            data-framer-name="Text Wrapper"
                          >
                            <div className="framer-srhmwy">
                              <div className="framer-yt32om">
                                <div
                                  className="framer-5dlm70 home-s77 reveal"
                                  data-framer-name="Track your spendings"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h3
                                    dir="auto"
                                    className="framer-text home-s78"
                                  >
                                    HOLD AND MOVE MONEY GLOBALLY
                                  </h3>
                                </div>
                                <div
                                  className="framer-rqbonu home-s79 reveal"
                                  data-framer-appear-id="rqbonu"
                                  data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Access multi-currency accounts with 52+ fiat
                                    currencies, plus stablecoins and digital
                                    assets, all in one place.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-91qh9v">
                              <div className="framer-jpofzf-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Send and swap money in 52+ currencies.
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-jvktaa-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Receive funds via local accounts in USD,
                                      EUR, GBP, and AED
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-18lynqn-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Convert and use additional currencies
                                      seamlessly
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-1ldlknd-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Instant conversion between all supported
                                      assets
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-14egb0j-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      One unified balance across everything
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*$*/}
                            <span
                              className="framer-1wikpdx framer-19sfakh home-s82"
                              data-border="true"
                              data-framer-name="Desktop"
                              href="/accounts"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1nnd3m0"
                                data-framer-name="Text"
                              >
                                <div
                                  className="framer-15vz0nq home-s83 reveal"
                                  data-framer-name="Title"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s84"
                                  >
                                    Explore Accounts
                                  </p>
                                </div>
                                <div
                                  className="framer-n2ti09"
                                  data-framer-name="Icon Flip"
                                >
                                  <div
                                    className="framer-198uhcc-container"
                                    data-framer-name="Feather 1"
                                    name="Feather 1"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                  <div
                                    className="framer-k83smd-container"
                                    data-framer-name="Feather 2"
                                    name="Feather 2"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                </div>
                              </div>
                            </span>
                            {/*/$*/}
                          </div>
                          <div className="framer-1qhinfb-container">
                            <div
                              className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s86"
                              data-framer-name="With Mask"
                            >
                              <div
                                className="framer-a6zh80 home-s87"
                                data-framer-name="Image"
                              >
                                <div className="framer-dx3wlc home-s88">
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="home-s31"
                                  >
                                    <img
                                      decoding="async"
                                      loading="lazy"
                                      width="499"
                                      height="1024"
                                      sizes="(min-width: 1440px) max((max((max(min(100vw - 80px, 1200px), 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (min-width: 810px) and (max-width: 1439.98px) max((max((max(min(100vw - 80px, 1200px), 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (max-width: 809.98px) max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px)"
                                      srcSet="/framerusercontent.com/images/iVYg6agNBEv7pvCTJGVp4HJahk.png 499w"
                                      src="/framerusercontent.com/images/iVYg6agNBEv7pvCTJGVp4HJahk.png"
                                      alt=""
                                      className="home-s89"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-ag6vic"
                    data-border="true"
                    data-framer-name="Feature 2"
                  >
                    <div className="ssr-variant">
                      <div className="framer-d5r81w-container">
                        {/*$*/}
                        <a
                          className="framer-2pnTs framer-1mbqquk framer-v-1212aml framer-19sfakh home-s76"
                          data-framer-name="Desktop 2"
                          href="/cards"
                        >
                          <div
                            className="framer-1682k4t"
                            data-framer-name="Text Wrapper"
                          >
                            <div className="framer-srhmwy">
                              <div className="framer-yt32om">
                                <div
                                  className="framer-5dlm70 home-s77 reveal"
                                  data-framer-name="Track your spendings"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h3
                                    dir="auto"
                                    className="framer-text home-s78"
                                  >
                                    SPEND DIRECTLY FROM YOUR BALANCE
                                  </h3>
                                </div>
                                <div
                                  className="framer-rqbonu home-s79 reveal"
                                  data-framer-appear-id="rqbonu"
                                  data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Use any asset you hold to pay online,
                                    in-store, or through mobile wallets.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-91qh9v">
                              <div className="framer-jpofzf-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Visa debit cards
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-jvktaa-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Unlimited virtual cards
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-18lynqn-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Apple Pay and Google Pay integration
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-1ldlknd-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Funded by any asset in your balance
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-14egb0j-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Auto top up{' '}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*$*/}
                            <span
                              className="framer-1wikpdx framer-19sfakh home-s82"
                              data-border="true"
                              data-framer-name="Desktop"
                              href="/cards"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1nnd3m0"
                                data-framer-name="Text"
                              >
                                <div
                                  className="framer-15vz0nq home-s83 reveal"
                                  data-framer-name="Title"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s84"
                                  >
                                    Explore Cards
                                  </p>
                                </div>
                                <div
                                  className="framer-n2ti09"
                                  data-framer-name="Icon Flip"
                                >
                                  <div
                                    className="framer-198uhcc-container"
                                    data-framer-name="Feather 1"
                                    name="Feather 1"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                  <div
                                    className="framer-k83smd-container"
                                    data-framer-name="Feather 2"
                                    name="Feather 2"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                </div>
                              </div>
                            </span>
                            {/*/$*/}
                          </div>
                          <div className="framer-1qhinfb-container">
                            <div
                              className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s86"
                              data-framer-name="With Mask"
                            >
                              <div
                                className="framer-a6zh80 home-s87"
                                data-framer-name="Image"
                              >
                                <div className="framer-dx3wlc home-s88">
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="home-s31"
                                  >
                                    <img
                                      decoding="async"
                                      loading="lazy"
                                      width="998"
                                      height="2048"
                                      sizes="(min-width: 1440px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(433 * 0.4965, 1px)), (min-width: 810px) and (max-width: 1439.98px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(401 * 0.4965, 1px)), (max-width: 809.98px) max(max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px), 164px)"
                                      srcSet="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png 998w"
                                      src="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png"
                                      alt=""
                                      className="home-s89"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1io48eq"
                    data-border="true"
                    data-framer-name="Feature 1"
                  >
                    <div className="ssr-variant">
                      <div className="framer-eoe6qr-container">
                        {/*$*/}
                        <a
                          className="framer-2pnTs framer-1mbqquk framer-v-1v7tayy framer-19sfakh home-s76"
                          data-framer-name="Desktop 3"
                          href="/scallop-pay"
                        >
                          <div
                            className="framer-1682k4t"
                            data-framer-name="Text Wrapper"
                          >
                            <div className="framer-srhmwy">
                              <div className="framer-yt32om">
                                <div
                                  className="framer-5dlm70 home-s77 reveal"
                                  data-framer-name="Track your spendings"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h3
                                    dir="auto"
                                    className="framer-text home-s78"
                                  >
                                    PAY LIKE A LOCAL. ANYWHERE.
                                  </h3>
                                </div>
                                <div
                                  className="framer-rqbonu home-s79 reveal"
                                  data-framer-appear-id="rqbonu"
                                  data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Use QR payments across local networks
                                    without local accounts or separate apps.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-91qh9v">
                              <div className="framer-jpofzf-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      PIX, GCash, VietQR, Yape, and more
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-jvktaa-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      No local wallet required
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-18lynqn-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Automatic FX conversion
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="framer-1ldlknd-container">
                                <div
                                  className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                  data-framer-name="Light"
                                >
                                  <div
                                    className="framer-1yxrvmv"
                                    data-framer-name="Icon Wrapper"
                                  >
                                    <div
                                      data-framer-component-type="SVG"
                                      data-framer-name="Icon"
                                      parentsize="0"
                                      _constraints="[object Object]"
                                      rotation="0"
                                      shadows=""
                                      className="framer-7gwxwc home-s81 reveal reveal-fast"
                                      aria-hidden="true"
                                    >
                                      <div className="svgContainer home-s34">
                                        <svg
                                          viewBox="0 0 32 32"
                                          className="home-s35"
                                        >
                                          <use href="#svg-1208994263_271" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="framer-194hyzz home-s79 reveal reveal-fast"
                                    data-framer-appear-id="194hyzz"
                                    data-framer-name="Up to 100,00 Tracked Visits"
                                    data-framer-component-type="RichTextContainer"
                                  >
                                    <p
                                      dir="auto"
                                      className="framer-text home-s80"
                                    >
                                      Real-time payments via local rails
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/*$*/}
                            <span
                              className="framer-1wikpdx framer-19sfakh home-s82"
                              data-border="true"
                              data-framer-name="Desktop"
                              href="/scallop-pay"
                              data-nested-link="true"
                              role="link"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1nnd3m0"
                                data-framer-name="Text"
                              >
                                <div
                                  className="framer-15vz0nq home-s83 reveal"
                                  data-framer-name="Title"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s84"
                                  >
                                    Explore Scallop Pay
                                  </p>
                                </div>
                                <div
                                  className="framer-n2ti09"
                                  data-framer-name="Icon Flip"
                                >
                                  <div
                                    className="framer-198uhcc-container"
                                    data-framer-name="Feather 1"
                                    name="Feather 1"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                  <div
                                    className="framer-k83smd-container"
                                    data-framer-name="Feather 2"
                                    name="Feather 2"
                                  >
                                    {/*$*/}
                                    <div className="home-s85" />
                                    {/*/$*/}
                                  </div>
                                </div>
                              </div>
                            </span>
                            {/*/$*/}
                          </div>
                          <div className="framer-1qhinfb-container">
                            <div
                              className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s86"
                              data-framer-name="With Mask"
                            >
                              <div
                                className="framer-a6zh80 home-s87"
                                data-framer-name="Image"
                              >
                                <div className="framer-dx3wlc home-s88">
                                  <div
                                    data-framer-background-image-wrapper="true"
                                    className="home-s31"
                                  >
                                    <img
                                      decoding="async"
                                      loading="lazy"
                                      width="998"
                                      height="2048"
                                      sizes="(min-width: 1440px) max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (min-width: 810px) and (max-width: 1439.98px) max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (max-width: 809.98px) max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px)"
                                      srcSet="/framerusercontent.com/images/GiJFg6AswmgiClDQUqNMRhKDXRk.png 998w"
                                      src="/framerusercontent.com/images/GiJFg6AswmgiClDQUqNMRhKDXRk.png"
                                      alt=""
                                      className="home-s89"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1c849rx hidden-15k5156">
              <div
                className="framer-15pykd3"
                data-framer-appear-id="15pykd3"
                data-framer-name="Features"
              >
                <div className="framer-jo3t4p" data-framer-name="Text">
                  <div
                    className="framer-1ny0wxj reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text home-s90">
                      Everything runs from one account
                    </h1>
                  </div>
                  <div
                    className="framer-tw9sh2 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s72">
                      Full access to core features across 120+ countries. No
                      regional limitations on how you use your money.
                    </p>
                  </div>
                </div>
                <div className="framer-kn2r9h" data-framer-name="Features">
                  <div
                    className="framer-bnjmvr"
                    data-border="true"
                    data-framer-name="Feature 1"
                  >
                    <div className="framer-iavqgc-container">
                      {/*$*/}
                      <a
                        className="framer-2pnTs framer-1mbqquk framer-v-1mz5rtc framer-19sfakh home-s91"
                        data-framer-name="Mobile"
                        href="/accounts"
                      >
                        <div
                          className="framer-1682k4t"
                          data-framer-name="Text Wrapper"
                        >
                          <div className="framer-srhmwy">
                            <div className="framer-yt32om">
                              <div
                                className="framer-5dlm70 home-s92 reveal"
                                data-framer-name="Track your spendings"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h3 dir="auto" className="framer-text home-s93">
                                  HOLD AND MOVE MONEY GLOBALLY
                                </h3>
                              </div>
                              <div
                                className="framer-rqbonu home-s94 reveal"
                                data-framer-appear-id="rqbonu"
                                data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s95">
                                  Access multi-currency accounts with 52+ fiat
                                  currencies, plus stablecoins and digital
                                  assets, all in one place.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="framer-91qh9v home-s69">
                            <div className="framer-jpofzf-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Send and swap money in 52+ currencies.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-jvktaa-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Receive funds via local accounts in USD,
                                    EUR, GBP, and AED
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-18lynqn-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Convert and use additional currencies
                                    seamlessly
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-1ldlknd-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Instant conversion between all supported
                                    assets
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-14egb0j-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    One unified balance across everything
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*$*/}
                          <span
                            className="framer-1wikpdx framer-19sfakh home-s82"
                            data-border="true"
                            data-framer-name="Desktop"
                            href="/accounts"
                            data-nested-link="true"
                            role="link"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1nnd3m0"
                              data-framer-name="Text"
                            >
                              <div
                                className="framer-15vz0nq home-s83 reveal"
                                data-framer-name="Title"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s84">
                                  Explore Accounts
                                </p>
                              </div>
                              <div
                                className="framer-n2ti09"
                                data-framer-name="Icon Flip"
                              >
                                <div
                                  className="framer-198uhcc-container"
                                  data-framer-name="Feather 1"
                                  name="Feather 1"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                                <div
                                  className="framer-k83smd-container"
                                  data-framer-name="Feather 2"
                                  name="Feather 2"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                              </div>
                            </div>
                          </span>
                          {/*/$*/}
                        </div>
                        <div className="framer-1qhinfb-container">
                          <div
                            className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s96"
                            data-framer-name="With Mask"
                          >
                            <div
                              className="framer-a6zh80 home-s87"
                              data-framer-name="Image"
                            >
                              <div className="framer-dx3wlc home-s88">
                                <div
                                  data-framer-background-image-wrapper="true"
                                  className="home-s31"
                                >
                                  <img
                                    decoding="async"
                                    loading="lazy"
                                    width="499"
                                    height="1024"
                                    sizes="(min-width: 1440px) max((max((max(min(100vw - 80px, 1200px), 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (min-width: 810px) and (max-width: 1439.98px) max((max((max(min(100vw - 80px, 1200px), 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (max-width: 809.98px) max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px)"
                                    srcSet="/framerusercontent.com/images/iVYg6agNBEv7pvCTJGVp4HJahk.png 499w"
                                    src="/framerusercontent.com/images/iVYg6agNBEv7pvCTJGVp4HJahk.png"
                                    alt=""
                                    className="home-s89"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                  <div
                    className="framer-ag6vic"
                    data-border="true"
                    data-framer-name="Feature 2"
                  >
                    <div className="framer-d5r81w-container">
                      {/*$*/}
                      <a
                        className="framer-2pnTs framer-1mbqquk framer-v-lkpcjj framer-19sfakh home-s91"
                        data-framer-name="Variant 8"
                        href="/cards"
                      >
                        <div
                          className="framer-1682k4t"
                          data-framer-name="Text Wrapper"
                        >
                          <div className="framer-srhmwy">
                            <div className="framer-yt32om">
                              <div
                                className="framer-5dlm70 home-s92 reveal"
                                data-framer-name="Track your spendings"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h3 dir="auto" className="framer-text home-s93">
                                  SPEND DIRECTLY FROM YOUR BALANCE
                                </h3>
                              </div>
                              <div
                                className="framer-rqbonu home-s94 reveal"
                                data-framer-appear-id="rqbonu"
                                data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s95">
                                  Use any asset you hold to pay online,
                                  in-store, or through mobile wallets.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="framer-91qh9v home-s69">
                            <div className="framer-jpofzf-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Visa debit cards
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-jvktaa-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Unlimited virtual cards
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-18lynqn-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Apple Pay and Google Pay integration
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-1ldlknd-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Funded by any asset in your balance
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-14egb0j-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Auto top up{' '}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*$*/}
                          <span
                            className="framer-1wikpdx framer-19sfakh home-s82"
                            data-border="true"
                            data-framer-name="Desktop"
                            href="/cards"
                            data-nested-link="true"
                            role="link"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1nnd3m0"
                              data-framer-name="Text"
                            >
                              <div
                                className="framer-15vz0nq home-s83 reveal"
                                data-framer-name="Title"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s84">
                                  Explore Cards
                                </p>
                              </div>
                              <div
                                className="framer-n2ti09"
                                data-framer-name="Icon Flip"
                              >
                                <div
                                  className="framer-198uhcc-container"
                                  data-framer-name="Feather 1"
                                  name="Feather 1"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                                <div
                                  className="framer-k83smd-container"
                                  data-framer-name="Feather 2"
                                  name="Feather 2"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                              </div>
                            </div>
                          </span>
                          {/*/$*/}
                        </div>
                        <div className="framer-1qhinfb-container">
                          <div
                            className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s96"
                            data-framer-name="With Mask"
                          >
                            <div
                              className="framer-a6zh80 home-s87"
                              data-framer-name="Image"
                            >
                              <div className="framer-dx3wlc home-s88">
                                <div
                                  data-framer-background-image-wrapper="true"
                                  className="home-s31"
                                >
                                  <img
                                    decoding="async"
                                    loading="lazy"
                                    width="998"
                                    height="2048"
                                    sizes="(min-width: 1440px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(433 * 0.4965, 1px)), (min-width: 810px) and (max-width: 1439.98px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(401 * 0.4965, 1px)), (max-width: 809.98px) max(max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px), 164px)"
                                    srcSet="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png 998w"
                                    src="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png"
                                    alt=""
                                    className="home-s89"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                  <div
                    className="framer-1io48eq"
                    data-border="true"
                    data-framer-name="Feature 1"
                  >
                    <div className="framer-eoe6qr-container">
                      {/*$*/}
                      <a
                        className="framer-2pnTs framer-1mbqquk framer-v-1pfv64k framer-19sfakh home-s91"
                        data-framer-name="Variant 7"
                        href="/scallop-pay"
                      >
                        <div
                          className="framer-1682k4t"
                          data-framer-name="Text Wrapper"
                        >
                          <div className="framer-srhmwy">
                            <div className="framer-yt32om">
                              <div
                                className="framer-5dlm70 home-s92 reveal"
                                data-framer-name="Track your spendings"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h3 dir="auto" className="framer-text home-s93">
                                  PAY LIKE A LOCAL. ANYWHERE.
                                </h3>
                              </div>
                              <div
                                className="framer-rqbonu home-s94 reveal"
                                data-framer-appear-id="rqbonu"
                                data-framer-name="Automatically categorize your spending, track where your money goes, and gain insights into your habits."
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s95">
                                  Use QR payments across local networks without
                                  local accounts or separate apps.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="framer-91qh9v home-s69">
                            <div className="framer-jpofzf-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    PIX, GCash, VietQR, Yape, and more
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-jvktaa-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    No local wallet required
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-18lynqn-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Automatic FX conversion
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="framer-1ldlknd-container">
                              <div
                                className="framer-rgTSi framer-uzn0bx framer-v-uzn0bx home-s3"
                                data-framer-name="Light"
                              >
                                <div
                                  className="framer-1yxrvmv"
                                  data-framer-name="Icon Wrapper"
                                >
                                  <div
                                    data-framer-component-type="SVG"
                                    data-framer-name="Icon"
                                    parentsize="0"
                                    _constraints="[object Object]"
                                    rotation="0"
                                    shadows=""
                                    className="framer-7gwxwc home-s81 reveal reveal-fast"
                                    aria-hidden="true"
                                  >
                                    <div className="svgContainer home-s34">
                                      <svg
                                        viewBox="0 0 32 32"
                                        className="home-s35"
                                      >
                                        <use href="#svg-1208994263_271" />
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="framer-194hyzz home-s79 reveal reveal-fast"
                                  data-framer-appear-id="194hyzz"
                                  data-framer-name="Up to 100,00 Tracked Visits"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p
                                    dir="auto"
                                    className="framer-text home-s80"
                                  >
                                    Real-time payments via local rails
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*$*/}
                          <span
                            className="framer-1wikpdx framer-19sfakh home-s82"
                            data-border="true"
                            data-framer-name="Desktop"
                            href="/scallop-pay"
                            data-nested-link="true"
                            role="link"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1nnd3m0"
                              data-framer-name="Text"
                            >
                              <div
                                className="framer-15vz0nq home-s83 reveal"
                                data-framer-name="Title"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s84">
                                  Explore Scallop Pay
                                </p>
                              </div>
                              <div
                                className="framer-n2ti09"
                                data-framer-name="Icon Flip"
                              >
                                <div
                                  className="framer-198uhcc-container"
                                  data-framer-name="Feather 1"
                                  name="Feather 1"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                                <div
                                  className="framer-k83smd-container"
                                  data-framer-name="Feather 2"
                                  name="Feather 2"
                                >
                                  {/*$*/}
                                  <div className="home-s85" />
                                  {/*/$*/}
                                </div>
                              </div>
                            </div>
                          </span>
                          {/*/$*/}
                        </div>
                        <div className="framer-1qhinfb-container">
                          <div
                            className="framer-ZOI4p framer-1dbqerp framer-v-1dbqerp home-s96"
                            data-framer-name="With Mask"
                          >
                            <div
                              className="framer-a6zh80 home-s87"
                              data-framer-name="Image"
                            >
                              <div className="framer-dx3wlc home-s88">
                                <div
                                  data-framer-background-image-wrapper="true"
                                  className="home-s31"
                                >
                                  <img
                                    decoding="async"
                                    loading="lazy"
                                    width="998"
                                    height="2048"
                                    sizes="(min-width: 1440px) max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (min-width: 810px) and (max-width: 1439.98px) max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), (max-width: 809.98px) max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px)"
                                    srcSet="/framerusercontent.com/images/GiJFg6AswmgiClDQUqNMRhKDXRk.png 998w"
                                    src="/framerusercontent.com/images/GiJFg6AswmgiClDQUqNMRhKDXRk.png"
                                    alt=""
                                    className="home-s89"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1dysur7" data-framer-name="Countries">
              <div className="framer-159sovg" data-framer-name="Text">
                <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                  <div
                    className="framer-1vzwimh reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw home-s23"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      &nbsp;Works where other financial
                      <br className="framer-text" />
                      apps don&rsquo;t
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-1vzwimh reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text home-s70">
                      &nbsp;Works where other financial
                      <br className="framer-text" />
                      apps don&rsquo;t
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                  <div
                    className="framer-1vzwimh reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw home-s23"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      &nbsp;Works where other financial apps don&rsquo;t
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg">
                  <div
                    className="framer-qjg2gq reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s71">
                      Full access to core features across 120+ countries. No
                      regional limitations on how you use your money.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-qjg2gq reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s72">
                      Full access to core features across 120+ countries. No
                      regional limitations on how you use your money.
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-cg0y28">
                <div className="framer-1rf3p80" data-framer-name="Countries">
                  <div className="framer-1rjfby7" data-framer-name="Stat">
                    <div
                      className="framer-nufrcg reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <h2 dir="auto" className="framer-text home-s97">
                        120+
                      </h2>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div className="framer-1kp1apx-container home-s98">
                        {/*$*/}
                        <div
                          className="framer-7JFet framer-4yba2 framer-1hpq6sa framer-v-1hpq6sa home-s99"
                          data-border="true"
                          data-framer-name="Desktop"
                        >
                          <div
                            className="framer-1wbbwsm home-s100 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              className="framer-text framer-styles-preset-2uggp1 home-s101"
                              data-styles-preset="yUb3soA9G"
                            >
                              Countries
                            </p>
                          </div>
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div className="framer-1kp1apx-container home-s98">
                        {/*$*/}
                        <div
                          className="framer-7JFet framer-4yba2 framer-1hpq6sa framer-v-1j5xuga home-s99"
                          data-border="true"
                          data-framer-name="Phone"
                        >
                          <div
                            className="framer-1wbbwsm home-s100 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              className="framer-text framer-styles-preset-2uggp1 home-s101"
                              data-styles-preset="yUb3soA9G"
                            >
                              Countries
                            </p>
                          </div>
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-1ow6vtj">
                      <div
                        data-framer-background-image-wrapper="true"
                        className="home-s31"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="735"
                          height="156"
                          sizes="(min-width: 1440px) 256px, (min-width: 810px) and (max-width: 1439.98px) 256px, (max-width: 809.98px) 256px"
                          srcSet="/framerusercontent.com/images/ILmqLuc9wEZ9otqKdI8OayJbdqE.png 512w,/framerusercontent.com/images/ILmqLuc9wEZ9otqKdI8OayJbdqE.png 735w"
                          src="/framerusercontent.com/images/ILmqLuc9wEZ9otqKdI8OayJbdqE.png"
                          alt=""
                          className="home-s32"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-18wdexv" data-framer-name="Glob">
                  <div className="framer-1u39nov" data-framer-name="Bottom">
                    <div className="framer-1t0s3x5" data-framer-name="Top">
                      <div className="framer-kzq0bp" data-framer-name="Video">
                        <div className="framer-1ed9x8c-container">
                          {/*$*/}
                          <video
                            ref={globeVideoRef}
                            src="/framerusercontent.com/assets/yjuD7GFXupvQlqYR8xjXBuh5oc.mp4"
                            loop
                            preload="auto"
                            muted
                            defaultMuted
                            playsInline
                            webkit-playsinline="true"
                            autoPlay
                            className="home-s102"
                          />
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="ssr-variant">
                        <div
                          className="framer-1cizgte home-s103"
                          data-framer-name="Cloud 01"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="529"
                              height="250"
                              sizes="(min-width: 1440px) 529px, (max-width: 809.98px) 317.4px, (min-width: 810px) and (max-width: 1439.98px) 473.984px"
                              srcSet="/framerusercontent.com/images/oUscxluBetLnso5wtiCRMM5TpDE.png 512w,/framerusercontent.com/images/oUscxluBetLnso5wtiCRMM5TpDE.png 529w"
                              src="/framerusercontent.com/images/oUscxluBetLnso5wtiCRMM5TpDE.png"
                              alt="Cloud"
                              className="home-s52"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="ssr-variant">
                        <div
                          className="framer-1nzezxd hidden-1kqrdcg home-s104"
                          data-framer-name="Cloud 03"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              loading="lazy"
                              width="749"
                              height="448"
                              sizes="(min-width: 1440px) 752.3438px, (max-width: 809.98px) 752.3438px, (min-width: 810px) and (max-width: 1439.98px) 412.9531px"
                              srcSet="/framerusercontent.com/images/vK1naOOAfBeOfzjSqlloxH7w.png 512w,/framerusercontent.com/images/vK1naOOAfBeOfzjSqlloxH7w.png 749w"
                              src="/framerusercontent.com/images/vK1naOOAfBeOfzjSqlloxH7w.png"
                              alt="Cloud"
                              className="home-s52"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-z6rvx3"
                        data-framer-name="Blur Overlay"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-9y07us" data-framer-name="Security">
              <div className="framer-1jc11b2" data-framer-name="Text">
                <div className="ssr-variant hidden-1kqrdcg">
                  <div
                    className="framer-1nkentr reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h2
                      className="framer-text framer-styles-preset-120m1vw home-s105"
                      data-styles-preset="Sp_YUSQNX"
                      dir="auto"
                    >
                      Built on regulated infrastructure
                    </h2>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-1nkentr reveal"
                    data-framer-name="Heading"
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1 dir="auto" className="framer-text home-s106">
                      Built on regulated infrastructure
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-1kqrdcg">
                  <div
                    className="framer-1i2b054 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s71">
                      Scallop operates with compliance, security, and global
                      payment connectivity at its core.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                  <div
                    className="framer-1i2b054 reveal"
                    data-framer-name="Description"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text home-s72">
                      Scallop operates with compliance, security, and global
                      payment connectivity at its core.
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-3u74ng">
                <div className="framer-1gavi3g">
                  <div className="framer-1ajq8je" data-border="true">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Frame"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-hz2aea home-s33"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 24 24" className="home-s35">
                          <use href="#svg826821621_616" />
                        </svg>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-w1emu8 home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s105"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          KYC and regulatory frameworks across multiple
                          jurisdictions
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-w1emu8 home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s107"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          KYC and regulatory frameworks across multiple
                          jurisdictions
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-dkfmeq" data-border="true">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Frame"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-7443wr home-s33"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 24 24" className="home-s35">
                          <use href="#svg826821621_616" />
                        </svg>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-d32x85 home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s105"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Integrated with global and local payment rails
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-d32x85 home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s107"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Integrated with global and local payment rails
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-nwe0i5">
                  <div className="framer-15yadgu" data-border="true">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Frame"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-1tmxm71 home-s33"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 24 24" className="home-s35">
                          <use href="#svg826821621_616" />
                        </svg>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-1ifxrax home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s105"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Secure custody and transaction monitoring
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-1ifxrax home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s107"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Secure custody and transaction monitoring
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-15hhqtt" data-border="true">
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Frame"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-13fsyrt home-s33"
                      aria-hidden="true"
                    >
                      <div className="svgContainer home-s34">
                        <svg viewBox="0 0 24 24" className="home-s35">
                          <use href="#svg826821621_616" />
                        </svg>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1kqrdcg">
                      <div
                        className="framer-dvdaf home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s105"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Trusted infrastructure partners
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                      <div
                        className="framer-dvdaf home-s27 reveal"
                        data-framer-name="Description"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-kwaq38 home-s107"
                          data-styles-preset="srRimenjh"
                          dir="auto"
                        >
                          Trusted infrastructure partners
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant">
                <div
                  className="framer-17dlct4 home-s108"
                  data-framer-name="image 1561"
                >
                  <div
                    data-framer-background-image-wrapper="true"
                    className="home-s31"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="360"
                      height="360"
                      src="/framerusercontent.com/images/qaZi8Aqk83hvVaYhNAO7SLlCLo.png"
                      alt=""
                      className="home-s32"
                    />
                  </div>
                </div>
              </div>
              <div className="framer-o79hi3" data-framer-name="Blur Overlay" />
            </div>
            <section
              className="framer-17vlsxj"
              data-framer-name="How it works section"
            >
              <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                <div className="framer-1dt51tj-container">
                  <div
                    className="framer-cO5Xn framer-e0qd9n framer-v-e0qd9n home-s109"
                    data-framer-name="Desktop 01"
                  >
                    <div className="framer-oiy9ek" data-framer-name="Left">
                      <div className="framer-bc6n4a">
                        <div
                          className="framer-ioyjrr"
                          data-framer-name="Heading and supporting text"
                        >
                          <div
                            className="framer-r2gnys home-s110 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h2 dir="auto" className="framer-text home-s111">
                              YOU CONTROL YOUR MONEY
                            </h2>
                          </div>
                          <div
                            className="framer-b414sw home-s112 reveal"
                            data-framer-name="Supporting text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s113" />
                          </div>
                        </div>
                        <div
                          className="framer-1hmsn9z"
                          data-framer-name="Icon Box List"
                        >
                          <div className="framer-1it8w7i-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 0 ? 'framer-v-46wece home-s114' : 'framer-v-16qccmr home-s119'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 0 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(0)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-5wo1B framer-1mag844 ${howItWorksIndex === 0 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#4128920373" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 0 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 0 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Biometric login &amp; Account protection
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1lzdxv8-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 1 ? 'framer-v-46wece home-s114' : 'framer-v-16qccmr home-s119'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 1 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(1)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-mz98p framer-1mag844 ${howItWorksIndex === 1 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#2758010082" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 1 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 1 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Real-time transaction alerts
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1dsbxes-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 2 ? 'framer-v-46wece home-s114' : 'framer-v-16qccmr home-s119'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 2 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(2)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-DV2tS framer-1mag844 ${howItWorksIndex === 2 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#1485826237" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 2 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 2 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Instant card controls
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-12i6w1o home-s123"
                      data-border="true"
                      data-framer-name="Right"
                    >
                      <div className="framer-1c7mm5i" data-framer-name="Images">
                        <div
                          className="framer-1oza88n"
                          data-framer-name="Image 1"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 0 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 0 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1ll1gcx home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/Layer1.png 998w"
                                src="/framerusercontent.com/images/Layer1.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-96xnf4"
                          data-framer-name="Image 2"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 1 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 1 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1gbd5ma home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png 998w"
                                src="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ahq1aj"
                          data-framer-name="Image 3"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 2 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 2 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-19xqtvz home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(433 * 0.4965, 1px)), (min-width: 810px) and (max-width: 1439.98px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(401 * 0.4965, 1px)), (max-width: 809.98px) max(max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px), 164px)"
                                srcSet="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png 998w"
                                src="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1oz04k home-s125"
                        data-framer-name="BgBlur"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                <div className="framer-1dt51tj-container">
                  <div
                    className="framer-cO5Xn framer-e0qd9n framer-v-1tzsv5k home-s109"
                    data-framer-name="Mobile 01"
                  >
                    <div className="framer-oiy9ek" data-framer-name="Left">
                      <div className="framer-bc6n4a">
                        <div
                          className="framer-ioyjrr"
                          data-framer-name="Heading and supporting text"
                        >
                          <div
                            className="framer-r2gnys home-s110 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h2 dir="auto" className="framer-text home-s126">
                              YOU CONTROL YOUR MONEY
                            </h2>
                          </div>
                          <div
                            className="framer-b414sw home-s112 reveal"
                            data-framer-name="Supporting text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s127" />
                          </div>
                        </div>
                        <div
                          className="framer-1hmsn9z"
                          data-framer-name="Icon Box List"
                        >
                          <div className="framer-1it8w7i-container home-s69">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 0 ? 'framer-v-46wece home-s128' : 'framer-v-16qccmr home-s129'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 0 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(0)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-5wo1B framer-1mag844 ${howItWorksIndex === 0 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#4128920373" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 0 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 0 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Biometric login &amp; Account protection
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1lzdxv8-container home-s69">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 1 ? 'framer-v-46wece home-s128' : 'framer-v-16qccmr home-s129'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 1 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(1)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-mz98p framer-1mag844 ${howItWorksIndex === 1 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#2758010082" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 1 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 1 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Real-time transaction alerts
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1dsbxes-container home-s69">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 2 ? 'framer-v-46wece home-s128' : 'framer-v-16qccmr home-s129'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 2 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(2)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-DV2tS framer-1mag844 ${howItWorksIndex === 2 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#1485826237" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 2 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 2 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Instant card controls
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-12i6w1o home-s130"
                      data-border="true"
                      data-framer-name="Right"
                    >
                      <div className="framer-1c7mm5i" data-framer-name="Images">
                        <div
                          className="framer-1oza88n"
                          data-framer-name="Image 1"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 0 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 0 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1ll1gcx home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/Layer1.png 998w"
                                src="/framerusercontent.com/images/Layer1.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-96xnf4"
                          data-framer-name="Image 2"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 1 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 1 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1gbd5ma home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png 998w"
                                src="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ahq1aj"
                          data-framer-name="Image 3"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 2 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 2 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-19xqtvz home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(433 * 0.4965, 1px)), (min-width: 810px) and (max-width: 1439.98px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(401 * 0.4965, 1px)), (max-width: 809.98px) max(max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px), 164px)"
                                srcSet="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png 998w"
                                src="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1oz04k home-s125"
                        data-framer-name="BgBlur"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                <div className="framer-1dt51tj-container">
                  <div
                    className="framer-cO5Xn framer-e0qd9n framer-v-bb2x3d home-s109"
                    data-framer-name="Tablet 01"
                  >
                    <div className="framer-oiy9ek" data-framer-name="Left">
                      <div className="framer-bc6n4a">
                        <div
                          className="framer-ioyjrr"
                          data-framer-name="Heading and supporting text"
                        >
                          <div
                            className="framer-r2gnys home-s110 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h2 dir="auto" className="framer-text home-s131">
                              YOU CONTROL YOUR MONEY
                            </h2>
                          </div>
                          <div
                            className="framer-b414sw home-s112 reveal"
                            data-framer-name="Supporting text"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s113" />
                          </div>
                        </div>
                        <div
                          className="framer-1hmsn9z"
                          data-framer-name="Icon Box List"
                        >
                          <div className="framer-1it8w7i-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 0 ? 'framer-v-46wece home-s132' : 'framer-v-16qccmr home-s133'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 0 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(0)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-5wo1B framer-1mag844 ${howItWorksIndex === 0 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#4128920373" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 0 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 0 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Biometric login &amp; Account protection
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1lzdxv8-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 1 ? 'framer-v-46wece home-s132' : 'framer-v-16qccmr home-s133'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 1 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(1)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-mz98p framer-1mag844 ${howItWorksIndex === 1 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#2758010082" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 1 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 1 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Real-time transaction alerts
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1dsbxes-container">
                            <div
                              className={`framer-GOdgB framer-1odpd79 ${howItWorksIndex === 2 ? 'framer-v-46wece home-s132' : 'framer-v-16qccmr home-s133'}`}
                              data-border="true"
                              data-framer-name={
                                howItWorksIndex === 2 ? 'Selected' : 'Light'
                              }
                              data-highlight="true"
                              tabIndex={0}
                              role="button"
                              onClick={() => setHowItWorksIndex(2)}
                            >
                              <div
                                className="framer-bn4x3c home-s115"
                                data-framer-name="Icon Bg"
                              >
                                <svg
                                  className={`framer-DV2tS framer-1mag844 ${howItWorksIndex === 2 ? 'home-s116' : 'home-s120'}`}
                                  role="presentation"
                                  viewBox="0 0 24 24"
                                >
                                  <use href="#1485826237" />
                                </svg>
                              </div>
                              <div
                                className="framer-hcwan2"
                                data-framer-name="Text Wrapper"
                              >
                                <div
                                  className={`framer-a6ee5t ${howItWorksIndex === 2 ? 'home-s117' : 'home-s121'}`}
                                  data-framer-name="Experience the future of eCommerce."
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className={`framer-text ${howItWorksIndex === 2 ? 'home-s118' : 'home-s122'}`}
                                  >
                                    Instant card controls
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-12i6w1o home-s134"
                      data-border="true"
                      data-framer-name="Right"
                    >
                      <div className="framer-1c7mm5i" data-framer-name="Images">
                        <div
                          className="framer-1oza88n"
                          data-framer-name="Image 1"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 0 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 0 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1ll1gcx home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/Layer1.png 998w"
                                src="/framerusercontent.com/images/Layer1.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-96xnf4"
                          data-framer-name="Image 2"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 1 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 1 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-1gbd5ma home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(433 * 0.4965, 1px), (max-width: 809.98px) 164px, (min-width: 810px) and (max-width: 1439.98px) max(401 * 0.4965, 1px)"
                                srcSet="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png 998w"
                                src="/framerusercontent.com/images/3tKl1fLwJg7JU9uFeXaewOzzxes.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="framer-1ahq1aj"
                          data-framer-name="Image 3"
                          style={{
                            position: 'absolute',
                            inset: 0,
                            opacity: howItWorksIndex === 2 ? 1 : 0,
                            transition: 'opacity 0.4s ease',
                            pointerEvents:
                              howItWorksIndex === 2 ? 'auto' : 'none',
                          }}
                        >
                          <div className="framer-19xqtvz home-s124">
                            <div
                              data-framer-background-image-wrapper="true"
                              className="home-s31"
                            >
                              <img
                                decoding="async"
                                loading="lazy"
                                width="998"
                                height="2048"
                                sizes="(min-width: 1440px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(433 * 0.4965, 1px)), (min-width: 810px) and (max-width: 1439.98px) max(max((max((max(min(100vw - 80px, 1200px) * 1, 1px) - 144px) / 2.25, 1px) - 48px) * 0.7, 1px), max(401 * 0.4965, 1px)), (max-width: 809.98px) max(max((calc(min(100vw - 32px, 1200px) - 32px) - 48px) * 0.7, 1px), 164px)"
                                srcSet="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png 998w"
                                src="/framerusercontent.com/images/yFToCeLL2ErKLuQTuUEh0h5j5d4.png"
                                alt=""
                                className="home-s52"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1oz04k home-s125"
                        data-framer-name="BgBlur"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-1l77iuy" data-framer-name="BgBlur" />
            </section>
            <div className="framer-1fcjed1" data-framer-name="Partners">
              <div className="framer-zpkuyw" data-framer-name="Partners">
                <div
                  className="framer-1bkvq2y home-s27 reveal"
                  data-framer-name="Description"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text home-s135">
                    Our trusted partners :
                  </p>
                </div>
                <div className="framer-s031qq-container">
                  {/*$*/}
                  <section className="home-s136">
                    <div className="marquee-track">
                      <ul className="home-s137">{partnerLogoItems}</ul>
                      <ul className="home-s137" aria-hidden="true">
                        {partnerLogoItems}
                      </ul>
                    </div>
                  </section>
                  {/*/$*/}
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
              <div className="framer-1ouqo9z-container" id="1ouqo9z">
                <div
                  className="framer-aDYo5 framer-68ykjv framer-v-68ykjv home-s140"
                  data-framer-name="Desktop"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div
                    data-framer-background-image-wrapper="true"
                    className="home-s31"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="5760"
                      height="2624"
                      sizes="(min-width: 1440px) 1200px, (max-width: 809.98px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 730px"
                      srcSet="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 512w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 1024w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 2048w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 4096w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 5760w"
                      src="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png"
                      alt=""
                      className="home-s32"
                    />
                  </div>
                  <div className="framer-1p77kfv" data-framer-name="Content">
                    <div className="framer-um74i7" data-framer-name="Content">
                      <div
                        className="framer-t2q0ke"
                        data-framer-name="Title+ Details+ Button"
                      >
                        <div
                          className="framer-2bxscg"
                          data-framer-name="Title & Details"
                        >
                          <div
                            className="framer-1ay74fr home-s141 reveal"
                            data-framer-name="Title"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h3 dir="auto" className="framer-text home-s142">
                              GET YOUR GLOBAL ACCOUNT TODAY.
                            </h3>
                          </div>
                          <div
                            className="framer-78wydy home-s143 reveal"
                            data-framer-name="Details"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s144">
                              One balance. 52+ currencies. Fiat and digital
                              assets.
                            </p>
                          </div>
                        </div>
                        {/*$*/}
                        <a
                          className="framer-1n718fg framer-mv3n2p"
                          data-framer-name="QR Overlay Trigger"
                        >
                          <div className="framer-1aija1g-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 home-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm home-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze home-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text home-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-1bpp82c" data-framer-name="Image">
                      <div
                        className="framer-bh8qo6 home-s145"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="home-s31"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1689"
                            height="2040"
                            sizes="(min-width: 1440px) 643px, (max-width: 809.98px) 550px, (min-width: 810px) and (max-width: 1439.98px) 643px"
                            srcSet="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 847w,/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 1689w"
                            src="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png"
                            alt=""
                            className="home-s32"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-4j6z79">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-2k8s12">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-g9q3em">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-15jkbl4">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1c849rx hidden-15k5156">
              <div className="framer-1ouqo9z-container" id="1ouqo9z">
                <div
                  className="framer-aDYo5 framer-68ykjv framer-v-yjbdxm home-s146"
                  data-framer-name="Phone"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div
                    data-framer-background-image-wrapper="true"
                    className="home-s31"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="5760"
                      height="2624"
                      sizes="(min-width: 1440px) 1200px, (max-width: 809.98px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 730px"
                      srcSet="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 512w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 1024w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 2048w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 4096w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 5760w"
                      src="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png"
                      alt=""
                      className="home-s32"
                    />
                  </div>
                  <div className="framer-1p77kfv" data-framer-name="Content">
                    <div className="framer-um74i7" data-framer-name="Content">
                      <div
                        className="framer-t2q0ke"
                        data-framer-name="Title+ Details+ Button"
                      >
                        <div
                          className="framer-2bxscg"
                          data-framer-name="Title & Details"
                        >
                          <div
                            className="framer-1ay74fr home-s141 reveal"
                            data-framer-name="Title"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h3 dir="auto" className="framer-text home-s147">
                              GET YOUR GLOBAL ACCOUNT TODAY.
                            </h3>
                          </div>
                          <div
                            className="framer-78wydy home-s143 reveal"
                            data-framer-name="Details"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s148">
                              One balance. 52+ currencies. Fiat and digital
                              assets.
                            </p>
                          </div>
                        </div>
                        {/*$*/}
                        <a
                          className="framer-1n718fg framer-mv3n2p"
                          data-framer-name="QR Overlay Trigger"
                          href="https://onelink.to/wch597"
                          target="_blank"
                          rel="noopener"
                        >
                          <div className="framer-1aija1g-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 home-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm home-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze home-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text home-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-1bpp82c" data-framer-name="Image">
                      <div
                        className="framer-bh8qo6 home-s145"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="home-s31"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1689"
                            height="2040"
                            sizes="(min-width: 1440px) 643px, (max-width: 809.98px) 550px, (min-width: 810px) and (max-width: 1439.98px) 643px"
                            srcSet="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 847w,/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 1689w"
                            src="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png"
                            alt=""
                            className="home-s32"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
              <div className="framer-1ouqo9z-container" id="1ouqo9z">
                <div
                  className="framer-aDYo5 framer-68ykjv framer-v-1dpum7x home-s140"
                  data-framer-name="Tablet"
                  data-highlight="true"
                  tabIndex={0}
                >
                  <div
                    data-framer-background-image-wrapper="true"
                    className="home-s31"
                  >
                    <img
                      decoding="async"
                      loading="lazy"
                      width="5760"
                      height="2624"
                      sizes="(min-width: 1440px) 1200px, (max-width: 809.98px) 100vw, (min-width: 810px) and (max-width: 1439.98px) 730px"
                      srcSet="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 512w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 1024w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 2048w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 4096w,/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png 5760w"
                      src="/framerusercontent.com/images/luF6GJ4aSqJimJzbnwPzDMkfL4w.png"
                      alt=""
                      className="home-s32"
                    />
                  </div>
                  <div className="framer-1p77kfv" data-framer-name="Content">
                    <div className="framer-um74i7" data-framer-name="Content">
                      <div
                        className="framer-t2q0ke"
                        data-framer-name="Title+ Details+ Button"
                      >
                        <div
                          className="framer-2bxscg"
                          data-framer-name="Title & Details"
                        >
                          <div
                            className="framer-1ay74fr home-s141 reveal"
                            data-framer-name="Title"
                            data-framer-component-type="RichTextContainer"
                          >
                            <h3 dir="auto" className="framer-text home-s149">
                              GET YOUR GLOBAL ACCOUNT TODAY.
                            </h3>
                          </div>
                          <div
                            className="framer-78wydy home-s143 reveal"
                            data-framer-name="Details"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s150">
                              One balance. 52+ currencies. Fiat and digital
                              assets.
                            </p>
                          </div>
                        </div>
                        {/*$*/}
                        <a
                          className="framer-1n718fg framer-mv3n2p"
                          data-framer-name="QR Overlay Trigger"
                        >
                          <div className="framer-1aija1g-container">
                            <div
                              className="framer-wWHmH framer-ly6l8a framer-v-18roq29 home-s12"
                              data-border="true"
                              data-framer-name="Variant 2"
                              data-highlight="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-1ebu3nm home-s13 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p dir="auto" className="framer-text home-s14">
                                  Get Started
                                </p>
                              </div>
                              <div
                                className="framer-1u4w7ze home-s15 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text home-s16">
                                  Coming soon
                                </p>
                              </div>
                            </div>
                          </div>
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                    <div className="framer-1bpp82c" data-framer-name="Image">
                      <div
                        className="framer-bh8qo6 home-s145"
                        data-framer-name="image 1560"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="home-s31"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1689"
                            height="2040"
                            sizes="(min-width: 1440px) 643px, (max-width: 809.98px) 550px, (min-width: 810px) and (max-width: 1439.98px) 643px"
                            srcSet="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 847w,/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png 1689w"
                            src="/framerusercontent.com/images/zvrQMmXOS9K4fVfZz5Yspvu54.png"
                            alt=""
                            className="home-s32"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-4j6z79">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-2k8s12">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-g9q3em">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                  <div className="framer-15jkbl4">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="home-s31"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="23"
                        height="23"
                        src="/framerusercontent.com/images/GjXyCKDkZg2fdBTyNSop4lw5X8.svg"
                        alt="icon"
                        className="home-s32"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1e3lcwc">
              <div className="ssr-variant hidden-1kqrdcg hidden-15k5156">
                <div className="framer-1hodcae-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-1rilglu home-s151"
                    data-framer-name="Desktop"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 699 196" className="home-s35">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k home-s152 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s153">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="home-s32"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpdesk"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpdesk"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko home-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer home-s34">
                              <svg viewBox="0 0 20 20" className="home-s35">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb home-s157 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s158">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu home-s159"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab home-s160"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1c849rx hidden-15k5156">
                <div className="framer-1hodcae-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 home-s151"
                    data-framer-name="Mobile"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 699 196" className="home-s35">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k home-s152 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s153">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="home-s32"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpdesk"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpdesk"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko home-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer home-s34">
                              <svg viewBox="0 0 20 20" className="home-s35">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb home-s157 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s158">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu home-s159"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab home-s160"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1c849rx hidden-1kqrdcg">
                <div className="framer-1hodcae-container">
                  <div
                    className="framer-60Kb5 framer-1rilglu framer-v-183e6ee home-s151"
                    data-framer-name="Tablet"
                  >
                    <div
                      className="framer-14npji9"
                      data-framer-name="Frame 33595"
                    >
                      <div className="framer-1nbyyte">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Logo + Logo Type"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ick3k6 home-s33"
                          aria-hidden="true"
                        >
                          <div className="svgContainer home-s34">
                            <svg viewBox="0 0 699 196" className="home-s35">
                              <use href="#svg-1137231340_6119" />
                            </svg>
                          </div>
                        </div>
                        <div className="framer-6st60f">
                          <div
                            className="framer-9nwe5k home-s152 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s153">
                              <strong className="framer-text">
                                One account for all your currencies{' '}
                                <br className="framer-text" />
                              </strong>
                              Manage, send, and receive money globally
                            </p>
                          </div>
                        </div>
                        <div
                          className="framer-1d0k7xa"
                          data-framer-name="ICO Logo_Blue"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="home-s31"
                          >
                            <img
                              decoding="async"
                              width="1440"
                              height="1440"
                              sizes="(min-width: 1440px) 60px, (max-width: 809.98px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px"
                              srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                              src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                              alt=""
                              className="home-s32"
                            />
                          </div>
                        </div>
                        <div className="scallop-compliance-note">
                          <p>
                            This website is managed by Scallop Pvt Limited, Sri Lanka.
                            <br />
                            Scallop does not provide services in the countries listed on
                            its{' '}
                            <a
                              href="https://docs.scallopx.com/details/onboarding-regions"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Prohibited Countries list
                            </a>
                            .
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-c50yne"
                        data-framer-name="Frame 33594"
                      >
                        <div className="framer-5dec6k" data-framer-name="Menu">
                          <div
                            className="framer-nmphiu home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Programs
                            </p>
                          </div>
                          <div
                            className="framer-1odpfed"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1tz9h0j-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/ambassador"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/ambassador"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Ambassador
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                          </div>
                        </div>
                        <div className="framer-a8htgk" data-framer-name="Menu">
                          <div
                            className="framer-1rugbzn home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Products
                            </p>
                          </div>
                          <div
                            className="framer-1oe4fxe"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-153yqwe-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/accounts"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/accounts"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Accounts
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1di1zw4-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/cards"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/cards"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Cards
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-165n05h-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-pay"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-pay"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Pay
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-1ddhrxh-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/scallop-plus"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/scallop-plus"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Plus
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-nsl31k-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://blog.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://blog.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Blogs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                        <div className="framer-bcfdyi" data-framer-name="Menu">
                          <div
                            className="framer-cv5tks home-s154 reveal"
                            data-framer-name="Heading"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s155">
                              Support
                            </p>
                          </div>
                          <div
                            className="framer-16j5a70"
                            data-framer-name="List"
                          >
                            {/*$*/}
                            <div className="framer-1apiy1v-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/support"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/support"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Contact Us
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            {/*$*/}
                            <div className="framer-650678-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="/helpdesk"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="/helpdesk"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      FAQs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                            {/*/$*/}
                            <div className="framer-1935128-container">
                              {/*$*/}
                              <a
                                className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                                data-framer-name="Link"
                                href="https://docs.scallopx.com/"
                              >
                                <div
                                  className="framer-wlx7jb home-s154 reveal"
                                  data-framer-name="Item"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <p className="framer-text home-s156">
                                    {/*$*/}
                                    <span
                                      className="framer-text framer-styles-preset-11r53mh"
                                      data-styles-preset="LO9i42feF"
                                      href="https://docs.scallopx.com/"
                                      rel="noopener"
                                      data-nested-link="true"
                                      role="link"
                                      tabIndex={0}
                                    >
                                      Scallop Docs
                                    </span>
                                    {/*/$*/}
                                  </p>
                                </div>
                              </a>
                              {/*/$*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1l4w042"
                      data-framer-name="Frame 33831"
                    >
                      <div className="framer-jk8g5w" data-framer-name="Link">
                        <div className="framer-80yh0c">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="ic:baseline-copyright"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-m3skko home-s33"
                            aria-hidden="true"
                          >
                            <div className="svgContainer home-s34">
                              <svg viewBox="0 0 20 20" className="home-s35">
                                <use href="#svg-1839680863_948" />
                              </svg>
                            </div>
                          </div>
                          <div
                            className="framer-hv1cvb home-s157 reveal"
                            data-framer-name="Item"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p dir="auto" className="framer-text home-s158">
                              2026 Scallop Group. All rights reserved.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1c28m8b">
                        {/*$*/}
                        <a
                          data-framer-component-type="SVG"
                          as="a"
                          data-framer-name="X"
                          href="https://x.com/Scallopcom"
                          target="_blank"
                          rel="noopener"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dziac9 framer-1d3y7cu home-s159"
                          aria-hidden="true"
                        />
                        {/*/$*/}
                        {/*$*/}
                        <a
                          className="framer-n9nhin framer-1d3y7cu"
                          data-framer-name="LinkdIn"
                          href="https://www.linkedin.com/company/scallopcom"
                          target="_blank"
                          rel="noopener"
                        >
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="linkd"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ggemab home-s160"
                            aria-hidden="true"
                          />
                        </a>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-htpygh-container">
            {/*$*/}
            {/*/$*/}
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default Home;
